<template>
  <MDBBtn
    ref="cleanUserDesigns"
    color="primary"
    aria-controls="cleanUserDesigns"
    @click="cleanUserDesignsStore()"
    style="display: none"
  >
    Clean user designs store
  </MDBBtn>
  <MDBBtn
    ref="btnOpenModalDesign"
    color="primary"
    aria-controls="openModelToDesign"
    @click="openModelToDesign = true"
    style="display: none"
  >
    
  </MDBBtn>
  <div>
    <button
      type="button"
      class="btn-addProductIdToUserDesigns"
      @click="addProductIdToUserDesigns()"
    > 
         style="display: none"

      click to add to user designs
    </button>
  </div>
  <div
    class="div-insertDesignsToVariantProduct"
    style="display: none"
    data-design-to-add=""
  >
    <button
      type="button"
      class="btn-insertDesignsToVariantProduct"
      @click="insertDesignsToVariantProduct()"
    ></button>
  </div>
  <div
    style="display: none"
  >
  insert Designs To Variant Product Change Design
    <button
      type="button"
      id="btn-insertDesignsToVariantProductChangeDesign"
      @click="insertDesignsToVariantProductChangeDesign()"
    ></button>
  </div>

  <div id="div-designImageData" data-design-img=""></div>
 
  <MDBModal
    id="openModelToDesign"
    tabindex="-1"
    labelledby="openModelToDesignTitle"
    v-model="openModelToDesign"
    centered
    
  >

    <MDBModalBody
    ref="modalBodyRef">
      <span style="display: flex; justify-content: space-between;">
        <h4 class="design-header">
          <b>Designer {{ store.allProducts[productId].productName }}</b>
        </h4>
        <span title="Close" @click="openModelToDesign = false">
          <img :src="store.baseIconsURL + '//Icons//ClosePopupIcon.png'" style="height: 10px" />
        </span>
      </span>
      <div class="contain-modal" style="display: block;" v-if="this.imageToPreview">
       
        <span v-if="this.store.userDesigns[this.productId].designs[this.variantId].imgVariants[this.imageToPreview] == undefined">
          <h4>
            <b>
              This product does not include Useful images for design,
              <br />
              Go to your admin area and mark images as Useful
            </b>
          </h4>
        </span>
       
        
        <div class="contain-order" v-else ref="modalContainRef">
          <div class="emb-order" @click="exitScroll()" ref="embOrderRef">
            <div class="emb-canvas-and-product-images">
              <div class="emb-canvas-with-editind">
                <div class="edit-canvas-line">
                  <span class="show-boundaries-element">
                    <MDBCheckbox
                      style="width: 20px; height: 20px; text-align: left;"
                      label="Show boundaries"
                      v-model="showBoundaries"
                    />
                  </span>
                  <span class="align-btns-container">
                    <span class="horizontal-align-btn" @click.stop="fixHorizontalOrVertical('Horizontal')">Horizontal</span>
                    <span class="vertical-align-btn" @click.stop="fixHorizontalOrVertical('Vertical')">Vertical</span>
                  </span>
                </div>
              <div
                ref="embCanvasCurrent"
                class="emb-canvas"
                :style="{
                  'background-image': getImgPath(getCurrentProduct()),
                  position: 'relative',
                }"
              >
                <div  
                  :style="{
                    'height': getCurrentProduct().box.heightInches * dpi + 'px',
                    'width': getCurrentProduct().box.widthInches * dpi + 'px',
                    'top':
                      getCurrentProduct().box.topLeftDmm.y * (dpi / 254.0) +
                      'px',
                    'left':
                      getCurrentProduct().box.topLeftDmm.x * (dpi / 254.0) +
                      'px',
                      'box-shadow': showBoundaries == true ? '#ffffff 0px 0px 0px 2px' : 'rgb(255 255 255 / 0%) 0px 0px 0px 2px',
                     'outline': showBoundaries == true ? 'dashed 2px yellow' : 'dashed 2px yellow',
                    'position': 'absolute',
                    'display': 'block',
                  }"
                  @click="exitScroll()"
                >
              <template
              v-for="(artObjectToShow, index) in this.store.userDesigns[
                      this.productId
                    ].designs[this.variantId].imgVariants[this.imageToPreview]
                      .arts"
                    :key="index">
                  
                                    <div
                                    ref="elementsRefsArray"
                                    :id="`target_${index}`"
                                    @click.stop="selectElementToPreview('art', index)"
                                    style="position: absolute;"
                                    >
                                    
                                    <DSTPreview
                                    
                                          :dwidth="(artObjectToShow.dragSize.w *
                                              this.dpi) /
                                            254.0"
                                          :dheight="(artObjectToShow.dragSize.h *
                                              this.dpi) /
                                            254.0"
                                          :dstFile="this.store.allArts.value[artObjectToShow.artID].sizes[
                                              artObjectToShow.artSizeID
                                            ].dstfile"
                                          :layersColors="artObjectToShow.colors"
                                          :arc="parseFloat(artObjectToShow.artArc)"
                                        >
                                        </DSTPreview>

                                       

                                </div>
                                   

                                <Moveable
                                    :target="`#target_${index}`"
                                    :style="`display: ${currentPreview == 'art' && currentPreviewIndex == index ? 'block' : 'none'}`"
                                    :draggable="true"
                                    :scalable="true"
                                    :rotatable="true"
                                    :keepRatio="true"
                                    :bounds="bounds"
                                    :snappable="true"
                                    
                                    @drag="onDrag($event, 'art', index)"
                                    @scale="onScale($event, 'art', index)"
                                    @rotate="onRotate($event, 'art', index)"
                                    @scaleEnd="OnScaleEnd($event, 'art', index)"
                                    />
                              </template>
                                   
                                      <vue-draggable-resizable
                                        v-for="(
                                          textObjectToShow, index
                                        ) in this.getUserDesignsTextsContentful()"
                                        :key="index"
                                        :resizable="false"
                                        :parent="true"
                                        @dragging="onDrag($event, 'text', index)"
                                        :w="(textObjectToShow.dragSize.w * dpi) / 254.0"
                                        :h="(textObjectToShow.dragSize.h * dpi) / 254.0"
                                        :x="(textObjectToShow.dragLocation.x * dpi) / 254.0"
                                        :y="(textObjectToShow.dragLocation.y * dpi) / 254.0"
                                        :style="{
                                          'box-shadow': currentPreview == 'text' && currentPreviewIndex == index ? '0 0 0 2px white' : 'none',
                                          'outline': currentPreview == 'text' && currentPreviewIndex == index ? 'dashed 2px black' : 'none'
                                        }"
                                        @click.stop="selectElementToPreview('text', index)"
                                      >
                                        <TextPreview
                                          :IDFontToPreview="textObjectToShow.fontID"
                                          :IDSizeFontToPreview="textObjectToShow.fontSizeID"
                                          :TextToPreview="textObjectToShow.text"
                                          :dpi="dpi"
                                          superPos="normal"
                                          :layersColors="textObjectToShow.layersColors"
                                          :x="0"
                                          :y="0"
                                          :arc="textObjectToShow.textArc"
                                        >
                                        </TextPreview>
                                      </vue-draggable-resizable>

                                      <vue-draggable-resizable
                                        v-for="(monogramObjectToShow, index) in this.store
                                          .userDesigns[this.productId].designs[this.variantId]
                                          .imgVariants[this.imageToPreview].monograms"
                                        :key="index"
                                        :resizable="false"
                                        :parent="true"
                                        @dragging="onDrag($event, 'monogram', index)"
                                        :w="(monogramObjectToShow.dragSize.w * dpi) / 254.0"
                                        :h="(monogramObjectToShow.dragSize.h * dpi) / 254.0"
                                        :x="(monogramObjectToShow.dragLocation.x * dpi) / 254.0"
                                        :y="(monogramObjectToShow.dragLocation.y * dpi) / 254.0"
                                        :style="{
                                          'box-shadow': currentPreview == 'monogram' && currentPreviewIndex == index ? '0 0 0 2px white' : 'none',
                                          'outline': currentPreview == 'monogram' && currentPreviewIndex == index ? 'dashed 2px black' : 'none',
                                        }"
                                        @click.stop="selectElementToPreview('monogram', index)"
                                      >
                                        <MonogramPreview
                                          :monogramObj="
                                            store.allMonograms.value[monogramObjectToShow.monogramID]
                                          "
                                          :colorLeftChar="monogramObjectToShow.colorsLeftChar"
                                          :colorMiddleChar="monogramObjectToShow.colorsMiddleChar"
                                          :colorRightChar="monogramObjectToShow.colorsRightChar"
                                          :char1="monogramObjectToShow.leftChar"
                                          :char2="monogramObjectToShow.middleChar"
                                          :char3="monogramObjectToShow.rightChar"
                                          :align="monogramObjectToShow.align"
                                          :distance1="monogramObjectToShow.distance1"
                                          :distance2="monogramObjectToShow.distance2"
                                          :dpi="dpi"
                                        >
                                        </MonogramPreview>
                                      </vue-draggable-resizable>
                                    </div>
                                    <div class="product-images" v-if="smallMobile == true">
                                  <div
                                    v-for="(
                                      image, index
                                    ) in this.store.getAllProductVariantUsefulImagesWithoutImg(
                                      this.productId,
                                      this.variantId,
                                      this.imageToPreview
                                    )"
                                    style="display: grid;"
                                    :key="index"
                                    class="img-container"
                                    @click.stop="changeImg(image)"
                                  >
                                  <div class="bg-image hover-zoom">
                                    <img
                                      ref="embCanvas"
                                      style="
                                        position: absolute;
                                        padding: 5px;
                                        max-width: 100%;
                                        max-height: 100%;
                                        align-items: center;
                                      "
                                      :title="image.imageName"
                                      :src="image.file.relativePath.replaceAll('\\', '\\\\')"
                                      hover-overlay
                                      hover-zoom
                                      hover-shadow
                                    />
                                  </div>
                                  <span style="font-size: 10px;">{{ image.imageName }}</span>
                                  </div>
                                </div>
                                  </div>
                                  </div>
                                <div class="product-images" v-if="smallMobile == false">
                                  <div
                                    v-for="(
                                      image, index
                                    ) in this.store.getAllProductVariantUsefulImagesWithoutImg(
                                      this.productId,
                                      this.variantId,
                                      this.imageToPreview
                                    )"
                                    :key="index"
                                    class="img-container"
                                    @click.stop="changeImg(image)"
                                  >
                                  <div class="bg-image hover-zoom">
                                    <img
                                      ref="embCanvas"
                                      style="
                                        position: absolute;
                                        padding: 5px;
                                        max-width: 100%;
                                        max-height: 100%;
                                        align-items: center;
                                      "
                                      :title="image.imageName"
                                      :src="image.file.relativePath.replaceAll('\\', '\\\\')"
                                      hover-overlay
                                      hover-zoom
                                      hover-shadow
                                    />
                                    </div>
                                    <span style="font-size: 10px;">{{ image.imageName }}</span>
                                  </div>
                                </div>
                                </div>
                                <div class="buttons-flex-full-screan" :style="{'display': smallMobile == true ? 'none' : showBuyBtns}">
                                <div class="qty"
                                ><span style="
                                    color: #686868; margin-right: 10px;">Quantity</span>
                                    <span class="product_quantity" style="font-family: 'Zen Kurenaido';
                                    font-size: 30px;
                                    color: #58595B;"
                                      >{{ qty }}</span
                                    >
                                </div>
                                <div
                                  v-if="isDesignCartElement == false"
                                  class="buy-btn"
                                  @click="addToCart()"
                                  title="Add to cart"
                                  style="display: grid; align-items: center;"
                                >
                                <div class="btn-add add-to-cart-btn">
                                    <span>Add To Cart</span>
                                    &nbsp;
                                  <img :src="store.baseIconsURL + '//Icons//AddToCartBlackIcon.png'" style="height: 25px" />
                                </div>
                                </div>
                              <div
                                  v-if="isDesignCartElement == false"
                                  class="buy-btn"
                                  @click="buyNow()"
                                  title="Buy now"
                                  style="display: grid; justify-items: center;"
                                >
                                <div class="btn-add buy-now-btn">
                                    <span style="color: #FFFFFF;">Buy Now</span>
                                    &nbsp;
                                  <img :src="store.baseIconsURL + '//Icons//BuyNowIcon.png'" style="height: 25px" />
                                </div>
                                </div>

                                <div
                                  v-if="isDesignCartElement == true"
                                  class="update-btn"
                                  @click="updateDesign()"
                                  title="Update design"
                                  style="display: grid; justify-items: center; margin-left: 10px"
                                >
                                  <div class="btn-add update-des-btn">
                                    <span style="color: #FFFFFF">Update Design</span>
                                  </div>
                                </div> 
                              </div>
                              </div>
                              
                              <div class="left-preview" ref="leftPreviewRef">
                                <div class="sub-buttons">
                                <div class="btn-radio" @click="ShowAllElements('text')" :style="{
                                          'border-bottom': currentPreview == 'text' ? '3px #72984F solid' : null}">
                                <div class="inner-btn-sub" :style="{'backgroundColor': currentPreview == 'text' ? '#72984F' : null,
                                'border-color': currentPreview == 'text' ? '#FFFFFF' : '#72984F'}">
                             
                                <div class="inner-btn-icon" :style="{
                                'background-image': currentPreview == 'text' ? 
                                'url(' + store.baseIconsURL + '/Icons/TextsIconWhite.png)' : 'url(' + store.baseIconsURL +  '/Icons/TextsIcon.png)'}">
                             
                                <span></span>
                                </div>
                                <div class="circle-btn" :style="{'font-family': 'Inter',
                                'backgroundColor': currentPreview == 'text' ? '#72984F' : null,
                                'border-color': currentPreview == 'text' ? '#FFFFFF' : '#72984F',
                                'color': currentPreview == 'text' ? '#FFFFFF' : null}">
                                {{Object.values(store.userDesigns[
                                        this.productId
                                      ].designs[this.variantId].imgVariants[this.imageToPreview]
                                        .texts).length}}
                                </div>
                                </div>
                                <lable :style="{'color': currentPreview == 'text' ? '#72984F' : null, 'font-size': '14px'}">Text</lable>
                                </div>

                                <div class="btn-radio" @click="ShowAllElements('art')" :style="{
                                          'border-bottom': currentPreview == 'art' ? '3px #72984F solid' : null}">            
                                <div class="inner-btn-sub" :style="{'backgroundColor': currentPreview == 'art' ? '#72984F' : null,
                                'border-color': currentPreview == 'art' ? '#FFFFFF' : '#72984F'}">
                                <div class="inner-btn-icon" :style="{
                                'background-image': currentPreview == 'art' ? 
                                'url(' + store.baseIconsURL + '/Icons/DesignsIconWhite.png)' : 'url(' + store.baseIconsURL + '/Icons/DesignsIcon.png)'}">
                                <span></span>
                                </div>
                                

                                <div class="circle-btn" :style="{'font-family': 'Inter',
                                'backgroundColor': currentPreview == 'art' ? '#72984F' : null,
                                'border-color': currentPreview == 'art' ? '#FFFFFF' : '#72984F',
                                'color': currentPreview == 'art' ? '#FFFFFF' : null}">
                                {{Object.values(store.userDesigns[
                                        this.productId
                                      ].designs[this.variantId].imgVariants[this.imageToPreview]
                                        .arts).length}}
                                </div>
                                </div>
                                <lable :style="{'color': currentPreview == 'art' ? '#72984F' : null, 'font-size': '14px'}">Art</lable>
                                </div>

                                <div class="btn-radio" @click="ShowAllElements('monogram')" :style="{
                                          'border-bottom': currentPreview == 'monogram' ? '3px #72984F solid' : null}">            
                                <div class="inner-btn-sub" :style="{'backgroundColor': currentPreview == 'monogram' ? '#72984F' : null,
                                'border-color': currentPreview == 'monogram' ? '#FFFFFF' : '#72984F'}">
                                <div class="inner-btn-icon" :style="{
                                'background-image': currentPreview == 'monogram' ? 
                                'url(' + store.baseIconsURL + '/Icons/MonogramsIconWhite.png)' : 'url(' + store.baseIconsURL + '/Icons/MonogramsIcon.png)'}">
                                <span></span>
                                </div>
                                
                                <div class="circle-btn" :style="{'font-family': 'Inter',
                                'backgroundColor': currentPreview == 'monogram' ? '#72984F' : null,
                                'border-color': currentPreview == 'monogram' ? '#FFFFFF' : '#72984F',
                                'color': currentPreview == 'monogram' ? '#FFFFFF' : null}">
                                {{Object.values(store.userDesigns[
                                        this.productId
                                      ].designs[this.variantId].imgVariants[this.imageToPreview]
                                        .monograms).length}}
                                </div>
                                </div>
                                <lable :style="{'color': currentPreview == 'monogram' ? '#72984F' : null, 'font-size': '14px'}">{{getMonogramLable()}}</lable>
                                </div>
                                </div>
                                <div class="preview-order">
                                  <div class="all-design-side" v-if="currentPreview == 'text'">
                                    <div class="public-btn-add-del">
                                    <span class="public-button btn-to-add-element" title="Add New Text" @click="addTextToDesign()">
                                      Add Text
                                      <img :src="store.baseIconsURL + '//Icons//PlusWhiteIcon.png'" style="height: 13px" />
                                    </span>
                                    <span class="public-button btn-to-del-all-element" title="Delete All Texts" @click="delAllTexts()">
                                      Delete All Texts
                                      <img :src="store.baseIconsURL + '//Icons//DeleteBlackIcon.png'" style="height: 13px" />
                                    </span>
                                    </div>
                                    
                                    <div class="design-side">
                                    <div
                                      v-for="(textDesignFromList, index) in this.store.userDesigns[
                                        this.productId
                                      ].designs[this.variantId].imgVariants[this.imageToPreview]
                                        .texts"
                                      :key="index"
                                    >
                                      <div class="item-line" @click="openElement('text', index)">
                                          <span class="float-left item-line-text">{{
                                            textDesignFromList.text != ""
                                              ? textDesignFromList.text
                                              : "-"
                                          }}</span>
                                          <span class="floatRight">
                                            <!-- <img for="option3" :src="{currentPreviewIndex == index ? '\Icons\OpenIcon.png' : '\Icons\CloseIcon.png'}" style="height: 20px" /> -->
                                            <span class="open-line-icon-span">
                                            <img
                                              v-if="currentPreviewIndex == index"
                                              :src="store.baseIconsURL + '//Icons//CloseIcon.png'"
                                              style="height: 7px; position: relative;"
                                            />
                                            <img
                                              v-if="currentPreviewIndex != index"
                                              :src="store.baseIconsURL + '//Icons//OpenIcon.png'"
                                              style="height: 7px; position: relative;"
                                            />
                                            </span>
                                            <span class="delete-icon-span"
                                              @click.stop="delText(currentPreviewIndex)">
                                            <img
                                              :src="store.baseIconsURL + '//Icons//DeleteIcon.png'"
                                              style="height: 17px; position: relative;"
                                            />
                                            </span>
                                          </span>
                                        </div>
                                      <div class="openLine" v-if="currentPreviewIndex == index">
                                        <div class="form-outline propLine">
                                          <label class="lableInOpenLine">Your Text</label>
                                          <input
                                            class="form-control openLineInput"
                                            type="text"
                                            v-model="
                                              store.userDesigns[this.productId].designs[
                                                this.variantId
                                              ].imgVariants[this.imageToPreview].texts[
                                                currentPreviewIndex
                                              ].text
                                            "
                                            @input="updateTextLocation(currentPreviewIndex)"
                                          />
                                        </div>

                                        <div>
                                          <div class="form-outline propLine" style="text-align: left;">
                                            <label class="lableInOpenLine">Font</label>
                                            
                                            <vue-select
                                              class="form-control openLineInput font-selected"
                                              :close-on-select="true"
                                              :min="1"
                                              :options="store.getAllTextFonts()"
                                              label-by="fontName"
                                              value-by="fontID"
                                              searchable
                                              :model-value="
                                                store.userDesigns[this.productId].designs[
                                                  this.variantId
                                                ].imgVariants[this.imageToPreview].texts[
                                                  currentPreviewIndex
                                                ].fontID
                                              "
                                              @update:modelValue="
                                                (value) => {
                                                  if (value !== null && value !== undefined) {
                                                    store.userDesigns[this.productId].designs[
                                                      this.variantId
                                                    ].imgVariants[this.imageToPreview].texts[
                                                      currentPreviewIndex
                                                    ].fontID = value;
                                                    updateFont(currentPreviewIndex);
                                                  }
                                                }
                                              "
                                            >
                                              <template #label="{ selected }">
                                                <template v-if="selected">
                                                  <div class="font-txt-preview">
                                                    <!-- {{ selected }} -->
                                                    <span class="txt-preview-comp" :style="{'width': ((store.getTextLength(selected.fontName, selected.fontID, Object.values(store.allFonts.value[selected.fontID].sizes)[0].sizeID) * dpi) / 254.0) + 'px'}">
                                                    <TextPreview
                                                      :IDFontToPreview="selected.fontID"
                                                      :IDSizeFontToPreview="Object.values(store.allFonts.value[selected.fontID].sizes)[0].sizeID"
                                                      :TextToPreview="selected.fontName"
                                                      :dpi="
                                                        (28.0 / store.allFonts.value[selected.fontID].sizes[Object.values(store.allFonts.value[selected.fontID].sizes)[0].sizeID].FontHeight) *
                                                        254.0
                                                      "
                                                      superPos="normal"
                                                      :layersColors="[store.blackColorIdDst]"
                                                      :x="0"
                                                      :y="0"
                                                    >
                                                    </TextPreview>
                                                  </span>
                                                    <!-- <span class="font-name">
                                                      {{ selected.fontName }}
                                                    </span> -->
                                                  </div>
                                                </template>
                                                <template v-else>
                                                  <div class="font-txt-preview">
                                                    <!-- {{ selected }} -->
                                                    <span class="txt-preview-comp" :style="{'width': (((store.getTextLength(Object.values(store.allFonts)[0].fontName, Object.values(store.allFonts)[0].fontID, Object.values(Object.values(store.allFonts)[0].sizes)[0].sizeID)) * dpi) / 254.0) + 'px'}">
                                                    <TextPreview
                                                      :IDFontToPreview="Object.values(store.allFonts)[0].fontID"
                                                      :IDSizeFontToPreview="Object.values(Object.values(store.allFonts)[0].sizes)[0].sizeID"
                                                      :TextToPreview="Object.values(store.allFonts)[0].fontName"
                                                      :dpi="
                                                        (28.0 / Object.values(store.allFonts)[0].sizes[Object.values(Object.values(store.allFonts)[0].sizes)[0].sizeID].FontHeight) *
                                                        254.0
                                                      "
                                                      superPos="normal"
                                                      :layersColors="[store.blackColorIdDst]"
                                                      :x="0"
                                                      :y="0"
                                                    >
                                                    </TextPreview>
                                                  </span>
                                                    <!-- <span class="font-name">
                                                    {{
                                                      Object.values(store.allFonts)[0].fontName
                                                    }}
                                                    </span> -->
                                                  </div>
                                                </template>
                                              </template>
                                              <template #dropdown-item="{ option }">
                                                <div class="font-txt-preview">
                                                    <!-- {{ selected }} -->
                                                    <span class="txt-preview-comp" :style="{'width': (((store.getTextLength(option.fontName, option.fontID, Object.values(store.allFonts.value[option.fontID].sizes)[0].sizeID)) * dpi) / 254.0) + 'px'}">
                                                  <!-- {{ option }} -->
                                                  <TextPreview
                                                      :IDFontToPreview="option.fontID"
                                                      :IDSizeFontToPreview="Object.values(store.allFonts.value[option.fontID].sizes)[0].sizeID"
                                                      :TextToPreview=option.fontName
                                                      :dpi="
                                                        (28.0 / store.allFonts.value[option.fontID].sizes[Object.values(store.allFonts.value[option.fontID].sizes)[0].sizeID].FontHeight) *
                                                        254.0
                                                      "
                                                      superPos="normal"
                                                      :layersColors="[store.blackColorIdDst]"
                                                      :x="0"
                                                      :y="0"
                                                    >
                                                    </TextPreview>
                                                  </span>
                                                    <!-- <span class="font-name">
                                                    {{ option.fontName }}
                                                    </span> -->
                                                </div>
                                              </template>
                                            </vue-select>
                                          </div>
                                        </div>

                                        <div class="form-outline propLine">
                                          <label class="lableInOpenLine">Size</label>
                                         
                                          <vue-select
                                            class="form-control openLineInput font-selected"
                                            :close-on-select="true"
                                            :min="1"
                                            v-if="
                                              store.userDesigns[this.productId].designs[
                                                this.variantId
                                              ].imgVariants[this.imageToPreview].texts[
                                                currentPreviewIndex
                                              ].fontID != 0
                                            "
                                            :options="
                                              store.getAllFontSizes(
                                                store.userDesigns[this.productId].designs[
                                                  this.variantId
                                                ].imgVariants[this.imageToPreview].texts[
                                                  currentPreviewIndex
                                                ].fontID
                                              )
                                            "
                                            label-by="sizeName"
                                            value-by="sizeID"
                                            searchable
                                            :model-value="
                                              store.userDesigns[this.productId].designs[
                                                this.variantId
                                              ].imgVariants[this.imageToPreview].texts[
                                                currentPreviewIndex
                                              ].fontSizeID
                                            "
                                            @update:modelValue="
                                              (value) => {
                                                if (value !== null && value !== undefined) {
                                                  store.userDesigns[this.productId].designs[
                                                    this.variantId
                                                  ].imgVariants[this.imageToPreview].texts[
                                                    currentPreviewIndex
                                                  ].fontSizeID = value;
                                                  updateTextLocation(currentPreviewIndex);
                                                }
                                              }
                                            "
                                          >
                                          </vue-select>
                                        </div>

                                        <div class="form-outline propLine">                           
                                          <div class="font-layers-colors-container">
                                            <template v-for="(layerColorID, index) in store.userDesigns[this.productId].designs[
                                                this.variantId
                                              ].imgVariants[this.imageToPreview].texts[
                                                currentPreviewIndex
                                              ].layersColors" :key="index">
                                                <SelectColor v-model="store.userDesigns[this.productId].designs[
                                                this.variantId
                                              ].imgVariants[this.imageToPreview].texts[
                                                currentPreviewIndex
                                              ].layersColors[index]"></SelectColor>
                                            </template>
                                          </div>
                                          <label class="lableInOpenLine">Color</label>                      
                                        </div>

                                        <div class="form-outline propLine">
                                          <label class="lableInOpenLine" style="display: flex; align-items: flex-end;"
                                            ><span>Arc </span>&nbsp;
                                            <span style="font-size: 12px;">{{
                                              store.userDesigns[this.productId].designs[
                                                this.variantId
                                              ].imgVariants[this.imageToPreview].texts[
                                                currentPreviewIndex
                                              ].textArc
                                            }}°</span>&nbsp;
                                          </label>
                                          <div class="form-control" style="display: flex; gap: 5px;">                        
                                            <span class="reset-arc" title="Reset Arc"
                                                @click="resetArc('text', currentPreviewIndex)">                          
                                            <img
                                              :src="store.baseIconsURL + '//Icons//ResetArcIcon.png'"
                                              style="height: 7px;"
                                            />
                                             
                                            </span>
                                            <MDBRange
                                              class="form-range"
                                              :min="-180"
                                              :max="180"
                                              v-model="
                                                store.userDesigns[this.productId].designs[
                                                  this.variantId
                                                ].imgVariants[this.imageToPreview].texts[
                                                  currentPreviewIndex
                                                ].textArc
                                              "
                                              @change="changeArc('text', currentPreviewIndex)"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    </div>
                                  </div>
                                  <div class="all-design-side" v-if="currentPreview == 'art'">
                                    <div class="public-btn-add-del">
                                    <span class="public-button btn-to-add-element" title="Add New Art" @click="addArt()">
                                      Add Art
                                      <img :src="store.baseIconsURL + '//Icons//PlusWhiteIcon.png'" style="height: 13px" />
                                    </span>
                                    <span class="public-button btn-to-del-all-element" title="Delete All Arts" @click="delAllArts()">
                                      Delete All Arts
                                      <img :src="store.baseIconsURL + '//Icons//DeleteBlackIcon.png'" style="height: 13px" />
                                    </span>
                                    </div>

                                    <div class="design-side">
                                      
                                    <div class="item-line" v-if="newArt != null" @click="openNewElement('art')">
                                          <span class="float-left item-line-text">Choose Art</span>
                                          <span class="floatRight">
                                            <span class="open-line-icon-span">
                                            <img
                                              v-if="newArt == 1"
                                              :src="store.baseIconsURL + '//Icons//CloseIcon.png'"
                                              style="height: 7px; position: relative;"
                                            />
                                            <img
                                              v-if="newArt == 0"
                                              :src="store.baseIconsURL + '//Icons//OpenIcon.png'"
                                              style="height: 7px; position: relative;"
                                            />
                                            </span>
                                            <span class="delete-icon-span"
                                              @click.stop="delAddLine('art')">
                                            <img
                                              :src="store.baseIconsURL + '//Icons//DeleteIcon.png'"
                                              style="height: 17px; position: relative;"
                                            />
                                            </span>
                                          </span>
                                            
                                      </div>
                                      <div class="openLine" v-if="newArt == 1">                      
                                        <div class="form-outline propLine">
                                          <span style="display: flex; align-items: center;">
                                          <input
                                            class="form-control openLineInput"
                                            style="height: 20px; font-size: 12px; border-radius: 0.5em;"
                                            type="text"
                                            :placeholder="'Search Design'"
                                            v-model="searchArtText"
                                          />
                                            <!-- @change="getArtBySearch()" -->
                                          <img
                                              :src="store.baseIconsURL + '//Icons//SearchIcon.png'"
                                              style="height: 13px;
                                                    left: -24px;
                                                    left: -22px;
                                                    position: relative;"
                                            />
                                          </span>
                                          <span style="width: 60%; height: 20px;">
                                          
                                            <vue-select
                                              title="Filter by art categories"
                                              multiple
                                              taggable
                                              :options="store.getArtCategoreiesList()"
                                              label-by="categoryName"
                                              value-by="categoryID"
                                              searchable
                                              :model-value="filterByArtCategories"
                                              @update:modelValue="(value) => {
                                              if (value !== null && value !== undefined) { 
                                                filterByArtCategories = value
                                              }
                                              }"
                                              label="Filter by art categories lable"
                                            >
                                            </vue-select>
                                            
                                          </span>
                                        </div>
                                      <div class="art-categories-container">
                                        <div
                                        v-for="(artCategory, indexArtCategory) in getArtBySearchGroupByCategories()"
                                        :key="indexArtCategory">
                                        <span class="art-category-title">{{ artCategory.categoryName }}</span>
                                        <div
                                            class="gallery-elements propLine" style="border: 0px; padding: 0px;"
                                          >
                                          <div
                                            v-for="(art, index) in artCategory.artsList"
                                            :key="index"
                                            @click="addArtToDesign(art)"
                                            :style="{
                                              width: '60px',
                                              height: '60px',
                                              border: '1px solid rgb(21, 72, 72)',
                                              'border-radius': '0.5em',
                                              position: 'relative'
                                            }"
                                          >
                                            <DSTPreview
                                              :dwidth="45"
                                              :dheight="45"
                                              :dstFile="
                                                art.sizes[Object.keys(art.sizes)[0]].dstfile
                                              "
                                              :layersColors="art.defaultColors"

                                            >
                                            </DSTPreview>
                                          </div>
                                        </div>
                                        </div>
                                      </div>
                                      </div>
                                      <div
                                      v-for="(artDesignFromList, index) in this.store.userDesigns[
                                        this.productId
                                      ].designs[this.variantId].imgVariants[this.imageToPreview]
                                        .arts"
                                      :key="index"
                                    >
                                      <div class="item-line" @click="openElement('art', index)">
                                          <span class="float-left item-line-text">{{
                                            artDesignFromList.artID > 0
                                              ? this.store.allArts.value[artDesignFromList.artID].artName
                                              : "-"
                                          }}</span>
                                          <span class="floatRight">
                                            <span class="open-line-icon-span">
                                            <img
                                              v-if="currentPreviewIndex == index"
                                              :src="store.baseIconsURL + '//Icons//CloseIcon.png'"
                                              style="height: 7px; position: relative;"
                                            />
                                            <img
                                              v-if="currentPreviewIndex != index"
                                              :src="store.baseIconsURL + '//Icons//OpenIcon.png'"
                                              style="height: 7px; position: relative;"
                                            />
                                            </span>
                                            <span class="delete-icon-span"
                                              @click.stop="delArt(currentPreviewIndex)">
                                            <img
                                              :src="store.baseIconsURL + '//Icons//DeleteIcon.png'"
                                              style="height: 17px; position: relative;"
                                            />
                                            </span>
                                          </span>
                                      </div>
                                      <div class="openLine" v-if="currentPreviewIndex == index" style="position: relative;">

                                        <div @click="closeChangePopup('art')" style="justify-content: center;
                                                    margin-bottom: 15px;
                                                    position: relative;
                                                    background-color: #f0f0f0;
                                                    height: 70px;
                                                    align-content: center;
                                                    display: grid;
                                                    border-radius: 0.5em;">
                                                    <div :style="{'height': 60 + 'px',
                                                                    'width': 60 + 'px',
                                                                    'position': 'relative'}">
                                          <DSTPreview
                                            :dwidth="45"
                                            :dheight="45"
                                            :dstFile="
                                              store.allArts.value[getCurrentArt().artID].sizes[getCurrentArt().artSizeID].dstfile
                                            "
                                            :layersColors="getCurrentArt().colors"
                                            :arc="parseFloat(getCurrentArt().artArc)"
                                            :left="6 + getArtTopLeft(getCurrentArt().artID, getCurrentArt().artSizeID, 45, 45, parseFloat(getCurrentArt().artArc)).left"
                                            :top="6 + getArtTopLeft(getCurrentArt().artID, getCurrentArt().artSizeID, 45, 45, parseFloat(getCurrentArt().artArc)).top"
                                            >
                                            </DSTPreview>
                                        </div>
                                        <span class="btn-to-change-element" title="Change Selected Monogram" @click.stop="openChangeArt()"
                                        style="position: absolute;
                                                right: 11px;
                                                bottom: 10px;
                                                width: 27px;
                                                height: 27px;
                                                background: #FFFFFF;
                                                box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
                                                border-radius: 0.5em;
                                                display: grid;
                                                align-items: center;
                                                justify-content: center;">
                                      <img :src="store.baseIconsURL + '//Icons//ChageSelectedGreenIcon.png'" style="height: 13px" />
                                    </span>
                                        </div>
                                        <div v-if="changeSelectedArt"                     
                                          style="z-index: 100;
                                                  position: absolute;
                                                  background-color: #FFFFFF;
                                                  width: 100%;
                                                  height: 100%;"
                                        >
                                        <div class="form-outline" style="display: flex;">
                                          <span style="display: flex; align-items: center;">
                                          <input
                                            class="form-control openLineInput"
                                            style="height: 20px; font-size: 12px; border-radius: 0.5em;"
                                            type="text"
                                            :placeholder="'Search Design'"
                                            v-model="searchArtText"
                                            @change="getArtBySearch()"
                                          />
                                          <img
                                              :src="store.baseIconsURL + '//Icons//SearchIcon.png'"
                                              style="height: 13px;
                                                    left: -24px;
                                                    left: -22px;
                                                    position: relative;"
                                            />
                                          </span>
                                          <span style="width: 60%; height: 20px;">
                                          
                                            <vue-select
                                              title="Filter by art categories"
                                              multiple
                                              taggable
                                              :options="store.getArtCategoreiesList()"
                                              label-by="categoryName"
                                              value-by="categoryID"
                                              searchable
                                              :model-value="filterByArtCategories"
                                              @update:modelValue="(value) => {
                                              if (value !== null && value !== undefined) { 
                                                filterByArtCategories = value
                                              }
                                              }"
                                              label="Filter by art categories lable"
                                            >
                                            </vue-select>
                                            
                                          </span>
                                        </div>
                                        <div class="art-categories-container">

                                        <div
                                        v-for="(artCategory, indexArtCategory) in getArtBySearchGroupByCategories()"
                                        :key="indexArtCategory">
                                        <span class="art-category-title">{{ artCategory.categoryName }}</span>
                                        <div
                                            class="gallery-elements propLine" style="border: 0px; padding: 0px;"
                                          >
                                        <div
                                            v-for="(art, index) in artCategory.artsList"
                                            :key="index"
                                            @click="changeArt(art)"
                                            :style="{
                                              width: '60px',
                                              height: '60px',
                                              border:
                                                art.artID == 
                                                store.userDesigns[this.productId].designs[
                                                  this.variantId
                                                ].imgVariants[this.imageToPreview].arts[
                                                  currentPreviewIndex
                                                ].artID
                                                  ? '3px solid #72984F'
                                                  : '1px solid rgb(21, 72, 72)',
                                              'border-radius': '0.5em',
                                              position: 'relative'
                                            }"
                                          >
                                            <DSTPreview
                                              :dwidth="45"
                                              :dheight="45"
                                              :dstFile="
                                                art.sizes[Object.keys(art.sizes)[0]].dstfile
                                              "
                                              :layersColors="art.defaultColors"
                                              :left="getArtTopLeft(art.artID, art.sizes[Object.keys(art.sizes)[0]].sizeID, 60, 60, 0).left"
                                              :top="getArtTopLeft(art.artID, art.sizes[Object.keys(art.sizes)[0]].sizeID, 60, 60, 0).top"
                                            >
                                            </DSTPreview>
                                          </div>
                                        </div>
                                        </div>
                                         
                                        </div>
                                          </div>

                                          <div class="form-outline propLine">
                                          <label class="lableInOpenLine">Size</label>
                                        
                                                <span @click="increaseArtSize()">+</span>
                                                &nbsp;
                                                <span @click="decreaseArtSize()">-</span>

                                          <vue-select
                                            class="form-control openLineInput font-selected"
                                            :close-on-select="true"
                                            :min="1"
                                            :options="
                                              store.getAllArtSizesNameID(
                                                store.userDesigns[this.productId].designs[
                                                  this.variantId
                                                ].imgVariants[this.imageToPreview].arts[
                                                  currentPreviewIndex
                                                ].artID
                                              )
                                            "
                                            label-by="sizeName"
                                            value-by="sizeID"
                                            searchable
                                            :model-value="
                                              store.userDesigns[this.productId].designs[
                                                this.variantId
                                              ].imgVariants[this.imageToPreview].arts[
                                                currentPreviewIndex
                                              ].artSizeID
                                            "
                                            @update:modelValue="
                                              (value) => {
                                                if (value !== null && value !== undefined) {
                                                  var artDesign = store.userDesigns[productId].designs[variantId].imgVariants[imageToPreview].arts[currentPreviewIndex];
                                                  artDesign.artSizeID = value;
                                                 
                                                  store.updateArtLocation(
                                                    this.productId,
                                                    this.variantId,
                                                    this.imageToPreview,
                                                    this.currentPreviewIndex,
                                                    store.userDesigns[this.productId].designs[this.variantId].imgVariants[this.imageToPreview].arts[this.currentPreviewIndex].artArc
                                                  );
                                           
                                                }
                                              }
                                            "
                                          >
                                          </vue-select>
                                        </div>

                                        <div class="form-outline propLine">
                                          <div class="colors-select-line" ref="colorsSelectLineRef">
                                            <div
                                              v-for="(layer, index) in this.store.userDesigns[
                                                this.productId
                                              ].designs[this.variantId].imgVariants[
                                                this.imageToPreview
                                              ].arts[currentPreviewIndex].colors"
                                              :key="index"
                                            >
                                            <SelectColor v-model="this.store.userDesigns[this.productId].designs[
                                                    this.variantId
                                                  ].imgVariants[this.imageToPreview].arts[
                                                    currentPreviewIndex
                                                  ].colors[index]">
                                          </SelectColor>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="form-outline propLine">
                                          <label class="lableInOpenLine" style="display: flex; align-items: flex-end;"
                                            ><span>Arc </span>&nbsp;
                                            <span style="font-size: 12px;">{{
                                              store.userDesigns[this.productId].designs[
                                                this.variantId
                                              ].imgVariants[this.imageToPreview].arts[
                                                currentPreviewIndex
                                              ].artArc
                                            }}°</span>&nbsp;
                                          </label>
                                          <div class="form-control" style="display: flex1;flex: 1; gap: 5px;">
                                            <span class="reset-arc" title="Reset Arc"
                                                @click="resetArc('art', currentPreviewIndex)">
                                              <img
                                              :src="store.baseIconsURL + '//Icons//ResetArcIcon.png'"
                                              style="height: 7px;"
                                              />
                                            </span>
                                            <MDBRange
                                              class="form-range"
                                              :min="-180"
                                              :max="180"
                                              v-model="
                                                store.userDesigns[this.productId].designs[
                                                  this.variantId
                                                ].imgVariants[this.imageToPreview].arts[
                                                  currentPreviewIndex
                                                ].artArc
                                              "
                                              @change="changeArc('art', currentPreviewIndex)"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    </div>
                                  </div>
                                  <div class="all-design-side" v-if="currentPreview == 'monogram'">
                                  <div class="public-btn-add-del">
                                    <span class="public-button btn-to-add-element" title="Add New Monogram" @click="addMonogram()">
                                      Add Monogram
                                      <img :src="store.baseIconsURL + '//Icons//PlusWhiteIcon.png'" style="height: 13px" />
                                    </span>
                                    <span class="public-button btn-to-del-all-element" title="Delete All Monograms" @click="delAllMonograms()">
                                      Delete All Monograms
                                      <img :src="store.baseIconsURL + '//Icons//DeleteBlackIcon.png'" style="height: 13px" />
                                    </span>
                                    </div>

                                    <div class="design-side">
                                      <div class="item-line" v-if="newMonogram != null" @click="openNewElement('monogram')">
                                          <span class="float-left item-line-text">Choose Monogram</span>
                                          <span class="floatRight">
                                            <span class="open-line-icon-span">
                                            <img
                                              v-if="newMonogram == 1"
                                              :src="store.baseIconsURL + '//Icons//CloseIcon.png'"
                                              style="height: 7px; position: relative;"
                                            />
                                            <img
                                              v-if="newMonogram == 0"
                                              :src="store.baseIconsURL + '//Icons//OpenIcon.png'"
                                              style="height: 7px; position: relative;"
                                            />
                                            </span>
                                            <span class="delete-icon-span"
                                              @click.stop="delAddLine('monogram')">
                                            <img
                                              :src="store.baseIconsURL + '//Icons//DeleteIcon.png'"
                                              style="height: 17px; position: relative;"
                                            />
                                            </span>
                                          </span>
                                            
                                      </div>
                                      <div class="openLine" v-if="newMonogram == 1">
                                      <div
                                          class="gallery-elements propLine"
                                        >
                                          <div
                                            v-for="(monogram, index) in store.getAllMonograms()"
                                            :key="index"
                                            @click="addMonogramToDesign(monogram)"
                                            :style="{
                                              width: '60px',
                                              height: '60px',
                                              position: 'relative',
                                              border: '1px solid rgb(21, 72, 72)',
                                              'border-radius': '0.5em'
                                            }"
                                          >
                                            <MonogramPreview
                                              :monogramObj="monogram"
                                              :colorLeftChar="monogram.leftChar.defaultColors"
                                              :colorMiddleChar="
                                                monogram.middleChar != null
                                                  ? monogram.middleChar.defaultColors
                                                  : null
                                              "
                                              :colorRightChar="monogram.rightChar.defaultColors"
                                              :char1="'A'"
                                              :char2="'B'"
                                              :char3="monogram.numOfCharacters == '2' ? 'B' : 'C'"
                                              :align="monogram.defaultAlignType"
                                              :distance1="monogram.distance1"
                                              :distance2="monogram.distance2"
                                              :dpi="dpi"
                                              :left="7.5 + getMonogramTopLeft(monogram.monogramID, 45, 45, 'A', 'B',
                                                    monogram.numOfCharacters == '2' ? 'B' : 'C', monogram.distance1, monogram.distance2).left"
                                              :top="7.5 + getMonogramTopLeft(monogram.monogramID, 45, 45, 'A', 'B',
                                                    monogram.numOfCharacters == '2' ? 'B' : 'C', monogram.distance1, monogram.distance2).top"
                                              :dh="45"
                                              :dw="45"
                                            >
                                            </MonogramPreview>
                                          </div>
                                        </div>
                                        </div>
                                    <div
                                      v-for="(monogramDesignFromList, index) in this.store
                                        .userDesigns[this.productId].designs[this.variantId]
                                        .imgVariants[this.imageToPreview].monograms"
                                      :key="index"
                                    >
                                      <div class="item-line" @click="openElement('monogram', index)">
                                          <span class="float-left item-line-text">{{
                                            monogramDesignFromList.monogramID > 0
                                              ? monogramDesignFromList.leftChar +
                                                (monogramDesignFromList.middleChar == null ? "" : monogramDesignFromList.middleChar) +
                                                monogramDesignFromList.rightChar
                                              : "-"
                                          }}</span>
                                          <span class="floatRight">
                                            <span class="open-line-icon-span">
                                            <img
                                              v-if="currentPreviewIndex == index"
                                              :src="store.baseIconsURL + '//Icons//CloseIcon.png'"
                                              style="height: 7px; position: relative;"
                                            />
                                            <img
                                              v-if="currentPreviewIndex != index"
                                              :src="store.baseIconsURL + '//Icons//OpenIcon.png'"
                                              style="height: 7px;  position: relative;"
                                            />
                                            </span>
                                            <span class="delete-icon-span"
                                              @click.stop="delMonogram(currentPreviewIndex)">
                                            <img
                                              :src="store.baseIconsURL + '//Icons//DeleteIcon.png'"
                                              style="height: 17px; position: relative;"
                                            />
                                            </span>
                                          </span>
                                        <!-- <img for="option3" :src="{currentPreviewIndex == index ? '\Icons\OpenIcon.png' : '\Icons\CloseIcon.png'}" style="height: 20px" /> -->
                                      </div>
                                      <div class="openLine" v-if="currentPreviewIndex == index">
                                        <div @click="closeChangePopup('monogram')" style="justify-content: center;
                                                    margin-bottom: 15px;
                                                    position: relative;
                                                    background-color: #f0f0f0;
                                                    height: 70px;
                                                    align-content: center;
                                                    display: grid;
                                                    border-radius: 0.5em;">
                                          <!-- <div :style="{'height': ((getMonogramDragSize().h * dpi) / 254.0) + 'px',
                                                                    'width': ((getMonogramDragSize().w * dpi) / 254.0) + 'px'}"> -->
                                        <div :style="{'height': 60 + 'px',
                                            'width': 60 + 'px'}">
                                          <MonogramPreview
                                          :monogramObj="
                                            store.allMonograms.value[getCurrentMonogram().monogramID]
                                          "
                                          :colorLeftChar="getCurrentMonogram().colorsLeftChar"
                                          :colorMiddleChar="
                                            store.userDesigns[this.productId].designs[
                                              this.variantId
                                            ].imgVariants[this.imageToPreview].monograms[
                                              currentPreviewIndex
                                            ].colorsMiddleChar
                                          "
                                          :colorRightChar="getCurrentMonogram().colorsRightChar"
                                          :char1="getCurrentMonogram().leftChar"
                                          :char2="getCurrentMonogram().middleChar"
                                          :char3="getCurrentMonogram().rightChar"
                                          :align="getCurrentMonogram().align"
                                          :distance1="getCurrentMonogram().distance1"
                                          :distance2="getCurrentMonogram().distance2"
                                          :dpi="dpi"
                                          :left="7.5 + getMonogramTopLeft(getCurrentMonogram().monogramID, 45, 45, getCurrentMonogram().leftChar != '' ? 
                                          getCurrentMonogram().leftChar : ' ', getCurrentMonogram().middleChar != '' ? 
                                          getCurrentMonogram().middleChar : ' ',
                                                    getCurrentMonogram().rightChar != '' ? 
                                          getCurrentMonogram().rightChar : ' ', getCurrentMonogram().distance1, getCurrentMonogram().distance2).left"
                                          :top="7.5 + getMonogramTopLeft(getCurrentMonogram().monogramID, 45, 45, getCurrentMonogram().leftChar, getCurrentMonogram().middleChar,
                                                    getCurrentMonogram().rightChar, getCurrentMonogram().distance1, getCurrentMonogram().distance2).top"
                                          :dh="45"
                                          :dw="45"
                                        >
                                        </MonogramPreview>
                                        </div>
                                        <span class="btn-to-change-element" title="Change Selected Monogram" @click.stop="openChangeMonogram()"
                                        style="position: absolute;
                                                right: 11px;
                                                bottom: 10px;
                                                width: 27px;
                                                height: 27px;
                                                background: #FFFFFF;
                                                box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
                                                border-radius: 0.5em;
                                                display: grid;
                                                align-items: center;
                                                justify-content: center;">
                                      <img :src="store.baseIconsURL + '//Icons//ChageSelectedGreenIcon.png'" style="height: 13px" />
                                    </span>
                                        </div>
                                        <div v-if="changeSelectedMonogram"
                                          class="gallery-elements propLine"
                                          style="z-index: 100;
                                                  position: absolute;
                                                  background-color: #FFFFFF;"
                                        >
                                          <div
                                            v-for="(monogram, index) in store.getAllMonograms()"
                                            :key="index"
                                            @click="changeMonogram(monogram)"
                                            :style="{
                                              width: '60px',
                                              height: '60px',
                                              position: 'relative',
                                              border:
                                                monogram.monogramID ==
                                                store.userDesigns[this.productId].designs[
                                                  this.variantId
                                                ].imgVariants[this.imageToPreview].monograms[
                                                  currentPreviewIndex
                                                ].monogramID
                                                  ? '3px solid #72984F'
                                                  : '1px solid rgb(21, 72, 72)',
                                              'border-radius':  '0.5em'
                                            }"
                                          >
                                          
                                            <MonogramPreview
                                              :monogramObj="monogram"
                                              :colorLeftChar="monogram.leftChar.defaultColors"
                                              :colorMiddleChar="
                                                monogram.middleChar != null
                                                  ? monogram.middleChar.defaultColors
                                                  : null
                                              "
                                              :colorRightChar="monogram.rightChar.defaultColors"
                                              :char1="'A'"
                                              :char2="'B'"
                                              :char3="monogram.numOfCharacters == '2' ? 'B' : 'C'"
                                              :align="monogram.defaultAlignType"
                                              :distance1="monogram.distance1"
                                              :distance2="monogram.distance2"
                                              :dpi="dpi"
                                              :left="7.5 + getMonogramTopLeft(monogram.monogramID, 45, 45, 'A', 'B',
                                                    monogram.numOfCharacters == '2' ? 'B' : 'C', monogram.distance1, monogram.distance2).left"
                                              :top="7.5 + getMonogramTopLeft(monogram.monogramID, 45, 45, 'A', 'B',
                                                    monogram.numOfCharacters == '2' ? 'B' : 'C', monogram.distance1, monogram.distance2).top"
                                              :dh="45"
                                              :dw="45"
                                            >
                                            </MonogramPreview>
                                          </div>
                                        </div>



                                        <div
                                          class="form-outline propLine"
                                          style="display: flex;
                                                  justify-content: space-around;
                                                  gap: 10px;"
                                        >
                                      <div :style="{
                                            'border': '1px solid #72984F',
                                            'border-radius': '0.5em', 'width': 'inherit',
                                          }">
                                              
                                          <div class="des-monogram-char">
                                            <label class="lableInOpenLine char-mono-lable" style="width: 30%;">Left</label>
                                            <input
                                              class="form-control char-input"
                                              :maxlength="1"
                                              type="text"
                                              style="text-align: center;
                                                    background-color: #FFFFFF;"
                                              v-model="getCurrentMonogram().leftChar"
                                              @input:modelValue="
                                                (value) => {
                                                  if (value !== null && value !== undefined) {
                                                    getCurrentMonogram().leftChar = (value == '' ? ' ' : value);
                                                    updateMonogramLocation(currentPreviewIndex);
                                                  }
                                                }
                                              "
                                              @input="updateMonogramLocation(currentPreviewIndex)"
                                            />

                                          </div>                      
                                              <!-- @change="updateMonogramLocation(currentPreviewIndex)" -->
                                          <div
                                                v-for="(layer, index) in this.store.userDesigns[
                                                  this.productId
                                                ].designs[this.variantId].imgVariants[
                                                  this.imageToPreview
                                                ].monograms[currentPreviewIndex].colorsLeftChar"
                                                :key="index"
                                                class="colors-monogram-char-inputs colors-inputs"
                                              style="width: fit-content;"
                                              >
                                              <SelectColor v-model="this.store.userDesigns[this.productId].designs[
                                                      this.variantId
                                                    ].imgVariants[this.imageToPreview].monograms[
                                                      currentPreviewIndex
                                                    ].colorsLeftChar[index]">
                                              </SelectColor>
                                              </div>
                                            </div>


                                          <div v-if="getCurrentMonogram().middleChar != null" :style="{
                                            'border': '1px solid #72984F',
                                            'border-radius': '0.5em', 'width': 'inherit'
                                          }">
                                              
                                          <div class="des-monogram-char">
                                            <label class="lableInOpenLine char-mono-lable" style="width: 30%;">Middle</label>
                                            <input
                                              class="form-control char-input"
                                              :maxlength="1"
                                              type="text"
                                              style="text-align: center;
                                                    background-color: #FFFFFF;"
                                              v-model="getCurrentMonogram().middleChar"
                                              @change:modelValue="
                                                (value) => {
                                                  if (value !== null && value !== undefined) {
                                                    getCurrentMonogram().middleChar = (value == '' ? ' ' : value);
                                                    updateMonogramLocation(currentPreviewIndex);
                                                  }
                                                }
                                              "
                                              @input="updateMonogramLocation(currentPreviewIndex)"
                                            />
                                              <!-- @change="updateMonogramLocation(currentPreviewIndex)" -->

                                          </div>
                                          <div
                                                v-for="(layer, index) in this.store.userDesigns[
                                                  this.productId
                                                ].designs[this.variantId].imgVariants[
                                                  this.imageToPreview
                                                ].monograms[currentPreviewIndex].colorsMiddleChar"
                                                :key="index"
                                                class="colors-monogram-char-inputs colors-inputs"
                                              style="width: fit-content;"
                                              >
                                              <SelectColor v-model="this.store.userDesigns[this.productId].designs[
                                                      this.variantId
                                                    ].imgVariants[this.imageToPreview].monograms[
                                                      currentPreviewIndex
                                                    ].colorsMiddleChar[index]">
                                              </SelectColor>
                                              </div>
                                            </div>


                                          <div :style="{
                                            'border': '1px solid #72984F',
                                            'border-radius': '0.5em', 'width': 'inherit',
                                          }">
                                          <div class="des-monogram-char">
                                            <label class="lableInOpenLine char-mono-lable" style="width: 30%;">Right</label>
                                            <input
                                              class="form-control char-input"
                                              :maxlength="1"
                                              type="text"
                                              style="text-align: center;
                                                    background-color: #FFFFFF;"
                                              v-model="getCurrentMonogram().rightChar"
                                              @change:modelValue="
                                                (value) => {
                                                  if (value !== null && value !== undefined) {
                                                    getCurrentMonogram().rightChar = (value == '' ? ' ' : value);
                                                    updateMonogramLocation(currentPreviewIndex);
                                                  }
                                                }
                                              "
                                              @input="updateMonogramLocation(currentPreviewIndex)"
                                            />

                                              <!-- @change="updateMonogramLocation(currentPreviewIndex)" -->
                                          </div>
                                          
                                            
                                              <div
                                                v-for="(layer, index) in this.store.userDesigns[
                                                  this.productId
                                                ].designs[this.variantId].imgVariants[
                                                  this.imageToPreview
                                                ].monograms[currentPreviewIndex].colorsRightChar"
                                                :key="index"
                                                class="colors-monogram-char-inputs colors-inputs"
                                              style="width: fit-content;"
                                              >
                                              <SelectColor v-model="this.store.userDesigns[this.productId].designs[
                                                      this.variantId
                                                    ].imgVariants[this.imageToPreview].monograms[
                                                      currentPreviewIndex
                                                    ].colorsRightChar[index]">
                                              </SelectColor>
                                              </div>
                                            </div>
                                        </div>

                                        


                                        <div class="form-outline propLine" style="justify-content: space-around;">
                                          <div style="display: flex; align-items: center;">
                                          <label class="lableInOpenLine" style="width: 19%; font-size: 14px;"
                                            >
                                            {{
                                              getCurrentMonogram().leftChar
                                            }} || {{
                                              getCurrentMonogram().middleChar != null ? getCurrentMonogram().middleChar : getCurrentMonogram().rightChar
                                            }}
                                          </label>
                                          <div class="form-control" style="display: flex; gap: 5px; width: auto; align-items: normal; background-color: #F9F9F9;">
                                            
                                            <span class="cancle-distance" title="Cancle Distance"
                                                @click="cancleDistance('1')">
                                              <img
                                              :src="store.baseIconsURL + '//Icons//ResetDistanceIcon.png'"
                                              style="height: 17px;"
                                              />
                                              <!-- <icon-svg
                                                :height="15"
                                                :width="15"
                                                icon="ph:arrow-arc-left-bold"
                                                @click="cancleDistance('1')"
                                              /> -->
                                            </span>
                                            <MDBRange
                                            class="form-range"
                                            :min="0"
                                            :max="getMaxDistance()"
                                            v-model="getCurrentMonogram().distance1"
                                            @change="updateMonogramLocation(currentPreviewIndex)"
                                          />
                                          </div>
                                          </div>
                                          <div v-if="getCurrentMonogram().middleChar != null" style="display: flex; align-items: center;">
                                          <label class="lableInOpenLine" style="width: 19%; font-size: 14px;"
                                            >
                                            {{
                                              getCurrentMonogram().middleChar
                                            }} || {{
                                              getCurrentMonogram().rightChar
                                            }}
                                          </label>
                                          <div class="form-control" style="display: flex; gap: 5px; width: auto; align-items: normal; background-color: #F9F9F9;">
                                            <span class="cancle-distance" title="Reset Distance"
                                                @click="cancleDistance('2')">
                                              <img
                                              :src="store.baseIconsURL + '//Icons//ResetDistanceIcon.png'"
                                              style="height: 17px;"
                                              />
                                       
                                            </span>
                                            <MDBRange
                                            class="form-range"
                                            :min="0"
                                            :max="getMaxDistance()"
                                            v-model="getCurrentMonogram().distance2"
                                            @change="updateMonogramLocation(currentPreviewIndex)"
                                          />
                                          </div>
                                          </div>
                                        </div>


                                      <div class="propLine">
                                        <label style="margin-right: 15px; font-size: 16px;">Align</label>
                                      <div style="display: flex;
                                                  gap: 10px;">
                                          <div
                                            :class="
                                              getCurrentMonogram().align == 'bottom'
                                                ? 'active-align'
                                                : 'align-option'
                                            "
                                            title="align bottom"
                                          >
                                            <icon-svg
                                              icon="carbon:align-vertical-bottom"
                                              @click="changeAlign('bottom')"
                                              :height="25"
                                              :width="25"
                                              :style="{margin: '3px', color: getCurrentMonogram().align == 'bottom' ? '#72984F' : 'rgba(88, 89, 91, 1)'}"
                                            />
                                          </div>
                                          <div
                                            :class="
                                              getCurrentMonogram().align == 'center'
                                                ? 'active-align'
                                                : 'align-option'
                                            "
                                            title="align center"
                                          >
                                            <icon-svg
                                              icon="carbon:align-vertical-center"
                                              @click="changeAlign('center')"
                                              :height="25"
                                              :width="25"
                                              :style="{margin: '3px', color: getCurrentMonogram().align == 'center' ? '#72984F' : 'rgba(88, 89, 91, 1)'}"
                                            />
                                          </div>
                                          <div
                                            :class="
                                              getCurrentMonogram().align == 'top'
                                                ? 'active-align'
                                                : 'align-option'
                                            "
                                            title="align top"
                                          >
                                            <icon-svg
                                              icon="carbon:align-vertical-top"
                                              @click="changeAlign('top')"
                                              :height="25"
                                              :width="25"
                                              :style="{margin: '3px', color: getCurrentMonogram().align == 'top' ? '#72984F' : 'rgba(88, 89, 91, 1)'}"
                                            />
                                          </div>
                                        </div>
                                        </div>

                                      </div>

                                    </div>
                                    </div>
                                  </div>
                                </div>

                              </div>
                              
                            </div>
                          </div>
                        </MDBModalBody>
                        <!-- MDBModalFooter -->
                        <div class="footer-buy-buttons">
                                <div class="buttons-flex-mobile" :style="{'display': smallMobile == true ? showBuyBtns : 'none'}">
                                <div class="qty"
                                ><span style="
                                    color: #686868; margin-right: 10px;">Qty</span>
                                    <span class="product_quantity" style="font-family: 'Zen Kurenaido';
                                    font-size: 30px;
                                    color: #58595B;"
                                      >{{ qty }}</span
                                    >
                                </div>
                                <div
                                  v-if="isDesignCartElement == false"
                                  class="buy-btn"
                                  @click="addToCart()"
                                  title="Add to cart"
                                  style="display: grid; align-items: center;"
                                >
                                <div class="btn-add add-to-cart-btn">
                                    <span>Add To Cart</span>
                                    &nbsp;
                                  <img :src="store.baseIconsURL + '//Icons//AddToCartBlackIcon.png'" style="height: 25px" />
                                </div>
                                </div>
                              <div
                                  v-if="isDesignCartElement == false"
                                  class="buy-btn"
                                  @click="buyNow()"
                                  title="Buy now"
                                  style="display: grid; justify-items: center;"
                                >
                                <div class="btn-add buy-now-btn">
                                    <span style="color: #FFFFFF;">Buy Now</span>
                                    &nbsp;
                                  <img :src="store.baseIconsURL + '//Icons//BuyNowIcon.png'" style="height: 25px" />
                                </div>
                                </div>
                                <div
                                  v-if="isDesignCartElement == true"
                                  class="update-btn"
                                  @click="updateDesign()"
                                  title="Update design"
                                >
                                  <div class="btn-add update-des-btn">
                                    <span style="color: #FFFFFF">Update Design</span>
                                  </div>
                                </div>
                              </div>
                        </div>
                      </MDBModal>
                    </template>

<script>
import { designerStore } from "@/stores/designerStore";
import VueDraggableResizable from 'vue-draggable-resizable'
// import VueDragResizeRotate from "vue3-drag-resize-rotate";
import VueSelect from "vue-next-select";
import TextPreview from "./TextPreview.vue";
import DSTPreview from "./DSTPreview.vue";
import MonogramPreview from "./MonogramPreview.vue";
import SelectColor from "./SelectColor.vue";
import Moveable from "vue3-moveable";
import {
  // MDBInput,
  MDBRange,
  // MDBSelect,
  MDBBtn,
  MDBModal,
  // MDBModalHeader,
  // MDBModalTitle,
  MDBModalBody,
  MDBCheckbox,
  // MDBModalFooter,
  // MDBBtnGroup,
  // MDBRadio,
  // MDBSpinner,
} from "mdb-vue-ui-kit";
import { nextTick } from "vue-demi";
import { ref } from "vue";

export default {
  setup() {
    const store = designerStore();
    const designUserModal = ref(true);
    const openModelToDesign = ref(false);
    const bounds = {"left":0,"top":0,"right":0,"bottom":0,"position":"css"};

    const elementsRefsArray = ref([]);
    const elementsMoveableArray = ref([]);

    return {
      store,
      designUserModal,
      openModelToDesign,
      bounds,

      elementsRefsArray,
      elementsMoveableArray
    };
  },
  components: {
    Moveable,
    SelectColor,
    VueDraggableResizable,
    // VueDragResizeRotate,
    VueSelect,
    // MDBInput,
    MDBRange,
    // MDBSelect,
    MDBBtn,
    MDBModal,
    // MDBModalHeader,
    // MDBModalTitle,
    MDBModalBody,
    MDBCheckbox,
    // MDBModalFooter,
    // MDBBtnGroup,
    // MDBRadio,
    // MDBSpinner,
    TextPreview,
    DSTPreview,
    MonogramPreview,
  },
  data() {
    return {
      showBoundaries: true,

      textPreview: null,
      artPreview: null,
      monogramPreview: null,

      showBuyBtns: "flex",

      newArt: null,
      newMonogram: null,

      changeSelectedArt: false,
      changeSelectedMonogram: false,

      searchArtText: "",

      smallMobile: false,
      smallColorsLine: false,

      currentPreviewIndex: -1,
      currentPreview: "",
      imageToPreview: null,
      dpi: 254.0,
      boxKey: 0,

      productId: null,
      variantId: null,
      productIdToUserDesigns: "",
      trueProp: true,
      finishLoading: true,
      isDesignCartElement: false,
      qty: 1,

      filterByArtCategories: [],

      rotating: false,
      x: 0,
      y: 0,
      width: 200,
      height: 200,
      rotate: 0,


    };
  },
  props: ["_productId", "_variantId", "_designObj", "_imgToPreview"],
  async mounted() {
    await this.store.checkUserDesignsStore();
    await this.store.syncShopifyProduct(); //מפעיל את סנכרון הסטור עם החנות

    // this.checkMonogramLable();
    window.addEventListener("resize", this.eventHandler);
    // console.log("this.productId mouted = ", this.productId);

    if(this._productId != null && this._productId != undefined) {
      this.showBuyBtns = "none";
    //   document.getElementById("btn-insertDesignsToVariantProductChangeDesign").click();
    }
   
    // this.productId = "8048607002920";
    // this.variantId = "44965326815528";
    // // Object.values(
    // //     this.store.allProducts[this.productId].variants
    // //   )[0].variantID;
    // this.imageToPreview = Object.values(
    //     this.store.allProducts[this.productId].variants[this.variantId].images
    //   )[0].imageName;
    //this.addProductIdToUserDesigns();


    // console.log('elementsRefsArray = ', this.elementsRefsArray);
    // await this.changeStyleByRef('art');
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.eventHandler);
  },
  methods: {
  cleanUserDesignsStore() {
  this.store.userDesigns = {};
  //Object.values(this.store.allProducts["8048603627816"].variants["44219817165096"].images)[0].isUseful = true;
  },
    async changeQty() {
      await nextTick();
      document.querySelector("input.quantity__input").value = this.qty;
      console.log("this.qty = ", this.qty);
    },
    async addToCart() {
      console.log("click add to cart in vue");
      var imgData = await this.store.getImgDataFromCartDesign(
        this.productId,
        this.variantId,
        // this.imageToPreview,
        this.store.userDesigns[this.productId].designs[this.variantId]
          .imgVariants
      );
      //eval("imgUrl")
      console.log("imgData = ", imgData);
      document.getElementById("div-designImageData").dataset["designImg"] =
        imgData;
      await eval("sendDesignToCart()");
      this.openModelToDesign = false;
      this.store.deleteVariantFromUserDesign(this.productId, this.variantId);
      await eval("reloadPage()");
    },
    async buyNow() {
      await this.addToCart();
      await eval("goToCart()");
    },
    async addProductIdToUserDesigns() {
      // this.productId = "8048603627816"; // "8048607002920";//eval("productId"); //"8827719614760"; //
      // this.variantId = "44219817165096"; // "44965326749992";//eval("variantId"); //"47361533247784"; //
      this.productId = "8838828589352";
      this.variantId = "47403201626408";
      // this.productId = eval("productId"); //"8827719614760"; //
      // this.variantId = eval("variantId"); //"47361533247784"; //

      //this.clearAllUserDesigns();
      // this.productId = eval("productId");
      // this.variantId = eval("variantId");
      // console.log("this.productId = ", this.productId);
      if (this.productId != undefined && this.variantId != undefined) {
        this.store.addProductToUserDesign(this.productId, this.variantId); // שולח לפונקציה את המספר שהוכנס
      }
      
      this.imageToPreview = Object.values(
        this.store.allProducts[this.productId].variants[this.variantId].images
      )[0].imageName;

      this.exitScroll();

      this.openModelToDesign = true;

      await nextTick();
      this.qty = 1; //document.querySelector("input.quantity__input").value; //

      this.designUserModal = true;
      await nextTick();
      this.$refs.btnOpenModalDesign.$el.click();
      this.finishLoading = false;

      
      // var modalWidth = this.$refs.embOrderRef != undefined ? this.$refs.embOrderRef.getBoundingClientRect().width : 0;
      var modalWidth = this.$refs.modalBodyRef != undefined ? this.$refs.modalBodyRef.$el.getBoundingClientRect().width : 0;
      // var modalWidth = this.$refs.modalContainRef != undefined ? this.$refs.modalContainRef.getBoundingClientRect().width : 0;
      if(modalWidth <= 600) {
         this.smallMobile = true; 
      } else {
        this.smallMobile = false;
      }

      var colorsWidth = this.$refs.colorsSelectLineRef != undefined ? this.$refs.colorsSelectLineRef[0].getBoundingClientRect().width : 0;
      if(colorsWidth <= 300) {
         this.smallColorsLine = true; 
      } else {
        this.smallColorsLine = false;
      }

      await this.calculateDpi();
      this.boxKey++;


      if(this.store.userDesigns[this.productId].designs[this.variantId]
        .imgVariants[this.imageToPreview].texts.length == 0) {
        this.addTextToDesign();
      }
      else {
        this.currentPreviewIndex =
          this.store.userDesigns[this.productId].designs[this.variantId]
            .imgVariants[this.imageToPreview].texts.length - 1;
      }
    await this.changeStyleByRef('art');
      this.currentPreview = "text";
    },
    async insertDesignsToVariantProduct() {
      this.isDesignCartElement = true;
      console.log(
        "insertDesignsToVariantProduct = ",
        document.getElementsByClassName("div-insertDesignsToVariantProduct")
      );
      //var design = document.getElementsByClassName("div-insertDesignsToVariantProduct").dataSet
      // this.productId = "8048607002920"; //eval("productId"); // "8048607002920";
      // this.variantId = "44965326749992"; //eval("variantId"); //"44965326815528";
      // this.productId = eval("productId"); // "8048607002920";
      // this.variantId = eval("variantId"); //"44965326815528";
      if (this.store.userDesigns[this.productId] === undefined) {
        this.store.userDesigns[this.productId] = {
          designIndex: this.productId,
          designID: this.store.createGuid(),
          productID: this.productId,
          designs: {},
        };
        this.store.userDesigns[this.productId].designs[this.variantId] =
          JSON.parse(
            document.getElementsByClassName(
              "div-insertDesignsToVariantProduct"
            )[0].dataset.designToAdd
          );
      } else {
        this.store.userDesigns[this.productId].designs[this.variantId] =
          JSON.parse(
            document.getElementsByClassName(
              "div-insertDesignsToVariantProduct"
            )[0].dataset.designToAdd
          );
      }
      this.imageToPreview = Object.values(
        this.store.allProducts[this.productId].variants[this.variantId].images
      )[0].imageName;

      this.exitScroll();

      await nextTick();
      this.qty = document.querySelector(".quantity__input[data-index='" + document.getElementById("input-cart-line").value + "']").value;

      this.designUserModal = true;
      await nextTick();
      this.$refs.btnOpenModalDesign.$el.click();
      this.finishLoading = false;

      // var modalWidth = this.$refs.embOrderRef != undefined ? this.$refs.embOrderRef.getBoundingClientRect().width : 0;
      var modalWidth = this.$refs.modalBodyRef != undefined ? this.$refs.modalBodyRef.$el.getBoundingClientRect().width : 0;
      // var modalWidth = this.$refs.modalContainRef != undefined ? this.$refs.modalContainRef.getBoundingClientRect().width : 0;
      if(modalWidth <= 600) {
         this.smallMobile = true; 
      } else {
        this.smallMobile = false;
      }

      var colorsWidth = this.$refs.colorsSelectLineRef != undefined ? this.$refs.colorsSelectLineRef[0].getBoundingClientRect().width : 0;
      if(colorsWidth <= 300) {
         this.smallColorsLine = true; 
      } else {
        this.smallColorsLine = false;
      }

      await this.calculateDpi();
      this.boxKey++;

      if(this.store.userDesigns[this.productId].designs[this.variantId]
        .imgVariants[this.imageToPreview].texts.length == 0) {
        this.addTextToDesign();
      }
      else {
        this.currentPreviewIndex =
          this.store.userDesigns[this.productId].designs[this.variantId]
            .imgVariants[this.imageToPreview].texts.length - 1;
      }
      this.currentPreview = "text";
    },

    
    async insertDesignsToVariantProductChangeDesign() {
      this.isDesignCartElement = true;
      console.log(
        "insertDesignsToVariantProductChangeDesign = ",
        document.getElementsByClassName("div-insertDesignsToVariantProduct")
      );
      this.productId = this._productId;
      this.variantId = this._variantId;
      if (this.store.userDesigns[this.productId] === undefined) {
        this.store.userDesigns[this.productId] = {
          designIndex: this.productId,
          designID: this.store.createGuid(),
          productID: this.productId,
          designs: {},
        };
        this.store.userDesigns[this.productId].designs[this.variantId] =
        this._designObj;
          // JSON.parse(
          //   document.getElementsByClassName(
          //     "div-insertDesignsToVariantProduct"
          //   )[0].dataset.designToAdd
          // );
      } else {
        this.store.userDesigns[this.productId].designs[this.variantId] =
        this._designObj;
          // JSON.parse(
          //   document.getElementsByClassName(
          //     "div-insertDesignsToVariantProduct"
          //   )[0].dataset.designToAdd
          // );
      }
      this.imageToPreview = 
      // this._imgToPreview;
      Object.values(
        this.store.allProducts[this.productId].variants[this.variantId].images
      )[0].imageName;

      this.exitScroll();

      this.openModelToDesign = true;

      await nextTick();
      // this.qty = document.querySelector(".quantity__input[data-index='" + document.getElementById("input-cart-line").value + "']").value;

      this.designUserModal = true;
      await nextTick();
      this.$refs.btnOpenModalDesign.$el.click();
      this.finishLoading = false;

      // var modalWidth = this.$refs.embOrderRef != undefined ? this.$refs.embOrderRef.getBoundingClientRect().width : 0;
      var modalWidth = this.$refs.modalBodyRef != undefined ? this.$refs.modalBodyRef.$el.getBoundingClientRect().width : 0;
      // var modalWidth = this.$refs.modalContainRef != undefined ? this.$refs.modalContainRef.getBoundingClientRect().width : 0;
      if(modalWidth <= 600) {
         this.smallMobile = true; 
      } else {
        this.smallMobile = false;
      }

      var colorsWidth = this.$refs.colorsSelectLineRef != undefined ? this.$refs.colorsSelectLineRef[0].getBoundingClientRect().width : 0;
      if(colorsWidth <= 300) {
         this.smallColorsLine = true; 
      } else {
        this.smallColorsLine = false;
      }

      await this.calculateDpi();
      this.boxKey++;

      if(this.store.userDesigns[this.productId].designs[this.variantId]
        .imgVariants[this.imageToPreview].texts.length == 0) {
        this.addTextToDesign();
      }
      else {
        this.currentPreviewIndex =
          this.store.userDesigns[this.productId].designs[this.variantId]
            .imgVariants[this.imageToPreview].texts.length - 1;
      }
      this.currentPreview = "text";
    },


    async updateDesign() {
      var imgData = await this.store.getImgDataFromCartDesign(
        this.productId,
        this.variantId,
        // this.imageToPreview,
        this.store.userDesigns[this.productId].designs[this.variantId]
          .imgVariants
      );
      console.log("imgData = ", imgData);
      document.getElementById("div-designImageData").dataset["designImg"] =
        imgData;
      await eval("updateDesignInCart()");
      document.getElementById("input-cart-line").value = "";
      this.isDesignCartElement = false;
      this.store.deleteVariantFromUserDesign(this.productId, this.variantId);
      await eval("reloadPage()");
    },
    async eventHandler() {
      // console.log("eventHandler function open");
      // this.checkMonogramLable();

      // var modalWidth = this.$refs.embOrderRef != undefined ? this.$refs.embOrderRef.getBoundingClientRect().width : 0;
      var modalWidth = this.$refs.modalBodyRef != undefined ? this.$refs.modalBodyRef.$el.getBoundingClientRect().width : 0;
      // var modalWidth = this.$refs.modalContainRef != undefined ? this.$refs.modalContainRef.getBoundingClientRect().width : 0;
      if(modalWidth <= 600) { 
        this.smallMobile = true;
      } else {
        this.smallMobile = false;
      }

      var colorsWidth = this.$refs.colorsSelectLineRef != undefined ? this.$refs.colorsSelectLineRef[0].getBoundingClientRect().width : 0;
      if(colorsWidth <= 300) {
         this.smallColorsLine = true; 
      } else {
        this.smallColorsLine = false;
      }

      await this.calculateDpi();
      await this.changeStyleByRef('art');
    },
    getMonogramLable() {
      var leftWidth = this.$refs.leftPreviewRef != undefined ? this.$refs.leftPreviewRef.getBoundingClientRect().width : 0;
      if(leftWidth < 350) { //window.innerWidth < 1190
        return "Mono"; // document.getElementById("monogram-sub-btn").innerHTML = "Mono";
      } else {
        return "Monogram"; // document.getElementById("monogram-sub-btn").innerHTML = "Monogram";
      }
    },
    // getDesignLable() {
    //   var leftWidth = this.$refs.leftPreviewRef != undefined ? this.$refs.leftPreviewRef.getBoundingClientRect().width : 0;
    //   if(leftWidth < 350) { //window.innerWidth < 1190
    //     return "Des"; // document.getElementById("monogram-sub-btn").innerHTML = "Mono";
    //   } else {
    //     return "Design"; // document.getElementById("monogram-sub-btn").innerHTML = "Monogram";
    //   }
    // },
    getCurVariantHash() {
      var md5 = require("md5");
      return md5(
        JSON.stringify(
          this.store.allProducts[this.productId].variants[this.variantId]
        )
      );
    },
    cleanSpecificUserDesign() {
      //לבדוק
      // var delIndex = Object.values(this.store.userDesigns).findIndex(f => f.designIndex == this.productId);
      // Object.values(this.store.userDesigns).splice(delIndex, 1);
      // Find the index of the design with the specified designIndex
      const indexToRemove = Object.keys(this.store.userDesigns).findIndex(key => this.store.userDesigns[key].designIndex === this.productId);

      // If the designIndex is found, remove it from the object
      if (indexToRemove !== -1) {
        // Remove the design object using delete
        delete this.store.userDesigns[this.productId];
      }
      
      //delete this.store.userDesigns[this.productId];
      this.addProductIdToUserDesigns();
    },
    getImgPath(image) {
      return "url(" + image.file.relativePath.replaceAll("\\", "\\\\") + ")";
      // return image.file.relativePath.replaceAll("\\", "\\\\");
    },
    async changeImg(image) {
      this.imageToPreview = image.imageName;
      if(this.store.userDesigns[this.productId].designs[this.variantId]
        .imgVariants[this.imageToPreview].texts.length == 0) {
        this.addTextToDesign();
      }
      else {
        this.currentPreviewIndex =
          this.store.userDesigns[this.productId].designs[this.variantId]
            .imgVariants[this.imageToPreview].texts.length - 1;
      }
      this.currentPreview = "text";
      // this.exitScroll();
      await this.calculateDpi();
    },
    addTextToDesign() {
      (this.textPreview = {
        imageName: this.imageToPreview,
        text: "",
        fontID: this.store.getAllFonts()[0].fontID,
        fontSizeID: Object.values(
          this.store.allFonts.value[Object.values(this.store.allFonts)[0].fontID]
            .sizes
        )[0].sizeID,
        layersColors: this.store.getAllColors().slice(0, 1).map(m => m.colorID),
        //colorID: this.store.blackColorIdDst,
        textArc: 0,
        location: { x: 0, y: 0, arc: 0 },
      }),
        this.store.addTextToDesign(
          this.productId,
          this.variantId,
          this.textPreview
        );
      this.currentPreviewIndex =
        this.store.userDesigns[this.productId].designs[this.variantId]
          .imgVariants[this.imageToPreview].texts.length - 1;
      this.currentPreview = "text";
    },
    async calculateDpi() {
      // console.log("calculateDpi function");
      if (this.imageToPreview != null) {
        await nextTick();
        const imgSizeFromHtml =
          this.$refs.embCanvasCurrent.getBoundingClientRect();

        // console.log("w = ", imgSizeFromHtml.width);
        // console.log("h = ", imgSizeFromHtml.height);

        var imgRatioFromHtml = imgSizeFromHtml.width / imgSizeFromHtml.height;
        var imgRatio =
          this.getCurrentProduct().imgWidthInches /
          this.getCurrentProduct().imgHeightInches;
        var width =
          imgRatio < imgRatioFromHtml
            ? this.getCurrentProduct().imgWidthInches *
              (imgSizeFromHtml.height /
                this.getCurrentProduct().imgHeightInches)
            : imgSizeFromHtml.width;

        this.dpi = width / this.getCurrentProduct().imgWidthInches;
      }
    },
    getArtDraggableSize(artObjectToShow) {
      this.boxKey++;
      return {
        x:
          (this.store.allArts.value[artObjectToShow.artID].sizes[
            artObjectToShow.artSizeID
          ].dstfile.pixelWidth *
            this.dpi) /
          254.0,
        y:
          (this.store.allArts.value[artObjectToShow.artID].sizes[
            artObjectToShow.artSizeID
          ].dstfile.pixelHeight *
            this.dpi) /
          254.0,
      };
    },
    resetArc(type, index) {
      switch (type) {
        case "art":
          this.store.userDesigns[this.productId].designs[
            this.variantId
          ].imgVariants[this.imageToPreview].arts[index].artArc = 0;
          this.changeArc(type, index);
          break;
        case "text":
          this.store.userDesigns[this.productId].designs[
            this.variantId
          ].imgVariants[this.imageToPreview].texts[index].textArc = 0;
          this.changeArc(type, index);
          break;
        default:
          break;
      }
    },
    cancleDistance(distanceNum) {
      if(distanceNum == "1" ) {this.getCurrentMonogram().distance1 = 0;}
      else if(distanceNum == "2" ) {this.getCurrentMonogram().distance2 = 0;}
      this.updateMonogramLocation(this.currentPreviewIndex);
    },
    delText(index) {
      this.store.delText(
        this.productId,
        this.variantId,
        this.imageToPreview,
        index
      );
      this.currentPreviewIndex = -1;
      // this.currentPreview = "";
    },
    delAllTexts() {
      this.store.userDesigns[this.productId].designs[
        this.variantId
      ].imgVariants[this.imageToPreview].texts = [];
      this.currentPreviewIndex = -1;
    },
    delArt(index) {
      this.store.delArt(
        this.productId,
        this.variantId,
        this.imageToPreview,
        index
      );
      this.currentPreviewIndex = -1;
    },
    delAllArts() {
      this.store.userDesigns[this.productId].designs[
        this.variantId
      ].imgVariants[this.imageToPreview].arts = [];
      this.currentPreviewIndex = -1;
      this.newArt = null;
    },
    changeAlign(align) {
      this.store.userDesigns[this.productId].designs[
        this.variantId
      ].imgVariants[this.imageToPreview].monograms[
        this.currentPreviewIndex
      ].align = align;
      this.updateMonogramLocation(this.currentPreviewIndex);
      this.boxKey++;
    },
    delMonogram(index) {
      this.store.delMonogram(
        this.productId,
        this.variantId,
        this.imageToPreview,
        index
      );
      this.currentPreviewIndex = -1;
    },
    delAllMonograms() {
      this.store.userDesigns[this.productId].designs[
        this.variantId
      ].imgVariants[this.imageToPreview].monograms = [];
      this.currentPreviewIndex = -1;
      this.newMonogram = null;
    },
    selectElementToPreview(type, index) {
      this.currentPreviewIndex = index;
      this.currentPreview = type;
    },
    fixHorizontalOrVertical(type) {
      var designs = this.store.userDesigns[
          this.productId
        ].designs[this.variantId].imgVariants[this.imageToPreview];

        
      //גודל הריבוע שתופס את האלמנט הבחור
      var dragBoxHeight = 0;
      var dragBoxWidth = 0;
      var objectToMove = {};

      if(this.currentPreview == 'text') {
        // dragBoxHeight = this.getUserDesignsTextsContentful()[this.currentPreviewIndex].dragSize.h * this.dpi;
        // dragBoxWidth = this.getUserDesignsTextsContentful()[this.currentPreviewIndex].dragSize.w * this.dpi;
        objectToMove = this.getUserDesignsTextsContentful()[this.currentPreviewIndex];
      } else if(this.currentPreview == 'art') {
        // dragBoxHeight = designs.arts[this.currentPreviewIndex].dragSize.h * this.dpi;
        // dragBoxWidth = designs.arts[this.currentPreviewIndex].dragSize.w * this.dpi;
        objectToMove = designs.arts[this.currentPreviewIndex];
      } else { //monogram
        // dragBoxHeight = designs.monograms[this.currentPreviewIndex].dragSize.h * this.dpi;
        // dragBoxWidth = designs.monograms[this.currentPreviewIndex].dragSize.w * this.dpi;
        objectToMove = designs.monograms[this.currentPreviewIndex];
      }

      dragBoxHeight = objectToMove.dragSize.h;
      dragBoxWidth = objectToMove.dragSize.w;
      if(type == 'Vertical') { //Vertical - לרוחב
        //גודל הקופסא של המוצר
        var boxHeight = this.getCurrentProduct().box.heightInches * 254;
        var artHeight = objectToMove.dragTransform.scale.scaleY * objectToMove.dragTransform.height;
        objectToMove.y = (boxHeight - artHeight) / 2;
        objectToMove.dragLocation.y = ((boxHeight - dragBoxHeight) / 2);
      } else { //לגובה
        //גודל הקופסא של המוצר
        var boxWidth = this.getCurrentProduct().box.widthInches * 254;
        objectToMove.dragLocation.x = ((boxWidth - dragBoxWidth) / 2);// - (dragBoxWidth / 2);
      }

      //מסדר את המיקום לגמרי גם ב
      //location
      if(this.currentPreview == 'text') {
        this.store.updateTextLocation(
          this.productId,
          this.variantId,
          this.imageToPreview,
          this.currentPreviewIndex,
          objectToMove.text,
          objectToMove.dragLocation.x,
          objectToMove.dragLocation.y,
          objectToMove.textArc,
          objectToMove.fontID,
          objectToMove.fontSizeID
        );
      } else if(this.currentPreview == 'art') {
        this.store.updateArtLocation(
          this.productId,
          this.variantId,
          this.imageToPreview,
          this.currentPreviewIndex,
          objectToMove.artArc
        );
      } else { //monogram        
        objectToMove.location = this.store.getMonogramLocation(
          this.store.allMonograms.value[objectToMove.monogramID],
          objectToMove.distance1,
          objectToMove.distance2,
          objectToMove.align,
          objectToMove.leftChar,
          objectToMove.middleChar,
          objectToMove.rightChar,
          objectToMove.dragLocation.x,
          objectToMove.dragLocation.y
        ).location;
      }

      // this.store.userDesigns[
      //                 this.productId
      //               ].designs[this.variantId].imgVariants[this.imageToPreview]
      //                 .arts
      // artObjectToShow.dragSize.w
      // getCurrentProduct().box.heightInches

    },
    openElement(type, index) {
      this.currentPreviewIndex = this.currentPreviewIndex == index ? -1 : index;
      this.currentPreview = type;
      this.changeSelectedArt = false;
      this.changeSelectedMonogram = false;
      // this.newMonogram = this.newMonogram == null ? null : 0;
      this.newArt = (this.newArt == true || this.newArt == false) ? false : null;
      this.newMonogram = (this.newMonogram == true || this.newMonogram == false) ? false : null;
    },
    openNewElement(type) {
      this.currentPreviewIndex = -1;
      if(type == 'monogram') {
        this.newMonogram = this.newMonogram == 0 ? 1 : 0;
      } else if(type == 'art') {
        this.newArt = this.newArt == 0 ? 1 : 0;
      }
    },
    openChangeMonogram() {
      this.changeSelectedMonogram = this.changeSelectedMonogram == false ? true : false;
    },
    openChangeArt() {
      this.changeSelectedArt = this.changeSelectedArt == false ? true : false;
    },
    addArt() {
      this.currentPreview = "art";
      this.newArt = 1;
      this.currentPreviewIndex = -1;
    },
    async addArtToDesign(art) {
      (this.artPreview = {
        imageName: this.imageToPreview,
        artID: art.artID,
        artSizeID: this.store.getAllArtSizes(art.artID)[0].sizeID,
        colors: art.defaultColors.map(
          (x) => x
        ),
        artArc: 0,
        location: { x: 0, y: 0, arc: 0 },
      }),
        this.store.addArtToDesign(
          this.productId,
          this.variantId,
          this.artPreview,
          this.dpi
          // this.imageToPreview,
          // art,
          // Object.values(art.sizes).find((x) => x.isAvailable == true).sizeID
        );
      this.currentPreviewIndex =
        this.store.userDesigns[this.productId].designs[this.variantId]
          .imgVariants[this.imageToPreview].arts.length - 1;
      this.currentPreview = "art";
      await this.changeStyleByRef('art');
      this.newArt = null;
      this.changeSelectedArt = false;
    },
    addMonogram() {
      this.currentPreview = "monogram";
      this.newMonogram = 1;
      this.currentPreviewIndex = -1;
    },
    addMonogramToDesign(monogram) {
      // var defaultMonogramObj = this.store.getAllMonograms()[0];
      (this.monogramPreview = {
        imageName: this.imageToPreview,
        monogramID: monogram.monogramID,
        colors: Object.values(this.store.allArts.value)[0].defaultColors.map(
          (x) => x
        ),
        numOfCharacters: monogram.numOfCharacters,
        location: { x: 0, y: 0, arc: 0 },
        align: monogram.defaultAlignType,
        distance1: monogram.distance1,
        distance2: monogram.distance2,
        leftChar: monogram.leftChar,
        middleChar: monogram.middleChar,
        rightChar: monogram.rightChar,
        colorsLeftChar: monogram.leftChar.defaultColors.map((x) => x),
        colorsMiddleChar:
          monogram.numOfCharacters != "2"
            ? monogram.middleChar.defaultColors.map((x) => x)
            : null,
        colorsRightChar: monogram.rightChar.defaultColors.map(
          (x) => x
        ),
      }),
        this.store.addMonogramToDesign(
          this.productId,
          this.variantId,
          this.monogramPreview
        );
      this.currentPreviewIndex =
        this.store.userDesigns[this.productId].designs[this.variantId]
          .imgVariants[this.imageToPreview].monograms.length - 1;
      this.currentPreview = "monogram";
      this.newMonogram = null;
      this.changeSelectedMonogram = false;
    },
    delAddLine(type) {
      if(type == 'monogram') {
        this.newMonogram = null;
      } else if(type == 'art') {
        this.newArt = null;
      }
      // this.currentPreviewIndex = null;
    },
    setArtColor(artDesignsIndex, layerIndex, value) {
      this.store.userDesigns[this.productId].designs[
        this.variantId
      ].imgVariants[this.imageToPreview].arts[artDesignsIndex].colors[
        layerIndex
      ] = value.colorID;
    },
    setMonogramColor(monogramDesignsIndex, layerIndex, value, charSide) {
      if (charSide == "left") {
        this.store.userDesigns[this.productId].designs[
          this.variantId
        ].imgVariants[this.imageToPreview].monograms[
          monogramDesignsIndex
        ].colorsLeftChar[layerIndex] = value.colorID;
      } else if (charSide == "middle") {
        this.store.userDesigns[this.productId].designs[
          this.variantId
        ].imgVariants[this.imageToPreview].monograms[
          monogramDesignsIndex
        ].colorsMiddleChar[layerIndex] = value.colorID;
      } else if (charSide == "right") {
        this.store.userDesigns[this.productId].designs[
          this.variantId
        ].imgVariants[this.imageToPreview].monograms[
          monogramDesignsIndex
        ].colorsRightChar[layerIndex] = value.colorID;
      }
    },
    changeArt(art) {
      var artSizeID = Object.values(art.sizes)[0].sizeID;
      this.store.userDesigns[this.productId].designs[
        this.variantId
      ].imgVariants[this.imageToPreview].arts[this.currentPreviewIndex].artID =
        art.artID;
      this.store.userDesigns[this.productId].designs[
        this.variantId
      ].imgVariants[this.imageToPreview].arts[
        this.currentPreviewIndex
      ].artSizeID = artSizeID;
      this.store.userDesigns[this.productId].designs[
        this.variantId
      ].imgVariants[this.imageToPreview].arts[this.currentPreviewIndex].colors =
        art.defaultColors.map((x) => x);

      this.store.updateArtLocation(
        this.productId,
        this.variantId,
        this.imageToPreview,
        this.currentPreviewIndex,
        this.store.userDesigns[this.productId].designs[this.variantId]
          .imgVariants[this.imageToPreview].arts[this.currentPreviewIndex]
          .artArc
      );
      this.changeSelectedArt= false;
    },
    changeMonogram(monogram) {
      this.store.userDesigns[this.productId].designs[
        this.variantId].imgVariants[this.imageToPreview].monograms[
        this.currentPreviewIndex].monogramID = monogram.monogramID;
      this.store.userDesigns[this.productId].designs[
        this.variantId].imgVariants[this.imageToPreview].monograms[
        this.currentPreviewIndex].leftChar = 'A';
        this.store.userDesigns[this.productId].designs[
        this.variantId].imgVariants[this.imageToPreview].monograms[
        this.currentPreviewIndex].numOfCharacters = monogram.numOfCharacters;
      this.store.userDesigns[this.productId].designs[
        this.variantId].imgVariants[this.imageToPreview].monograms[
        this.currentPreviewIndex].middleChar = monogram.numOfCharacters != "2" ? 'B' : null;
      this.store.userDesigns[this.productId].designs[
        this.variantId].imgVariants[this.imageToPreview].monograms[
        this.currentPreviewIndex].rightChar = monogram.numOfCharacters == "2" ? 'B' : 'C';
      this.store.userDesigns[this.productId].designs[
        this.variantId].imgVariants[this.imageToPreview].monograms[
        this.currentPreviewIndex].colorsLeftChar = monogram.leftChar.defaultColors.map((x) => x);
      this.store.userDesigns[this.productId].designs[
        this.variantId].imgVariants[this.imageToPreview].monograms[
        this.currentPreviewIndex].colorsMiddleChar =
        monogram.middleChar != null
          ? monogram.middleChar.defaultColors.map((x) => x)
          : null;
      this.store.userDesigns[this.productId].designs[
        this.variantId].imgVariants[this.imageToPreview].monograms[
        this.currentPreviewIndex].colorsRightChar = monogram.rightChar.defaultColors.map((x) => x);
      //distance 1 is correct
      this.store.userDesigns[this.productId].designs[
        this.variantId
      ].imgVariants[this.imageToPreview].monograms[
        this.currentPreviewIndex
      ].distance2 =
        monogram.numOfCharacters != "2"
          ? monogram.distance2 != null
            ? monogram.distance2
            : 0
          : null;
    this.updateMonogramLocation(this.currentPreviewIndex);
    this.changeSelectedMonogram = false;
    },
    onDrag(e, type, index) {
      // console.log('dpi = ', this.dpi);
      this.selectElementToPreview(type, index);
      var obj = null;
      if (type == "text") {
        obj =
          this.store.userDesigns[this.productId].designs[this.variantId]
            .imgVariants[this.imageToPreview].texts[index];
        // obj.dragLocation.x = (el.left / this.dpi) * 254.0;
        // obj.dragLocation.y = (el.top / this.dpi) * 254.0;
        this.store.updateTextLocation(
          this.productId,
          this.variantId,
          this.imageToPreview,
          index,
          obj.text,
          obj.dragLocation.x,
          obj.dragLocation.y,
          obj.textArc,
          obj.fontID,
          obj.fontSizeID
        );
      } else if (type == "art") {
        obj =
          this.store.userDesigns[this.productId].designs[this.variantId]
            .imgVariants[this.imageToPreview].arts[index];
        // obj.dragLocation.x = (el.left / this.dpi) * 254.0;
        // obj.dragLocation.y = (el.top / this.dpi) * 254.0;
        // var h = (this.store.allArts.value[obj.artID].sizes[obj.artSizeID].dstfile.pixelHeight *this.dpi) / 254.0;
        // var w = (this.store.allArts.value[obj.artID].sizes[obj.artSizeID].dstfile.pixelWidth * this.dpi) / 254.0;
        e.target.style.transform = e.transform;
        var trans = this.getStyleByTransform(e.transform, (e.width * 254) / this.dpi, (e.height * 254) / this.dpi);
        obj.dragTransform = trans;

        // e.target.style.transform = e.transform;
        // e.target.style.transform = `translate(${obj.dragTransform.x}px,  ${obj.dragTransform.y}px), scale(${obj.dragTransform.scale.scaleX}, ${obj.dragTransform.scale.scaleY}), rotate(${obj.dragTransform.rotate}deg);`;
        // this.store.updateArtLocation(
        //   this.productId,
        //   this.variantId,
        //   this.imageToPreview,
        //   index,
        //   this.store.userDesigns[this.productId].designs[this.variantId]
        //     .imgVariants[this.imageToPreview].arts[index].artArc
        // );
      } else if (type == "monogram") {
        obj =
          this.store.userDesigns[this.productId].designs[this.variantId]
            .imgVariants[this.imageToPreview].monograms[index];
        // obj.dragLocation.x = (el.left / this.dpi) * 254.0;
        // obj.dragLocation.y = (el.top / this.dpi) * 254.0;
        obj.location = this.store.getMonogramLocation(
          this.store.allMonograms.value[obj.monogramID],
          obj.distance1,
          obj.distance2,
          obj.align,
          obj.leftChar,
          obj.middleChar,
          obj.rightChar,
          obj.dragLocation.x,
          obj.dragLocation.y
        ).location;
      }
    },
    OnScaleEnd(e, type, index) {
      console.log('e = ', e);
      console.log('type = ', type);
      console.log('index = ', index);
      // if (type == "text") {
      //   console.log('e = ', e);
      // } else if (type == "art") {
      //   var newSizeId = this.store.findingNearestArtSize(this.store.userDesigns[this.productId].designs[this.variantId].imgVariants[this.imageToPreview].arts[index], this.dpi);
      //   this.store.userDesigns[this.productId].designs[this.variantId].imgVariants[this.imageToPreview].arts[index].artSizeID = newSizeId;
      // } else if (type == "monogram") {
      //   console.log('e = ', e);
      // }
    },
    onScale(e, type, index) {
      // console.log('dpi = ', this.dpi);
      // e.target.style.transform = e.transform;
      var trans = this.getStyleByTransform(e.transform, this.extractFloatNumber(e.target.style.width) * 254 / this.dpi, this.extractFloatNumber(e.target.style.height) * 254 / this.dpi);
      this.selectElementToPreview(type, index);
      var obj = null;
      if (type == "text") {
        obj =
          this.store.userDesigns[this.productId].designs[this.variantId]
            .imgVariants[this.imageToPreview].texts[index];
        // obj.dragLocation.x = (el.left / this.dpi) * 254.0;
        // obj.dragLocation.y = (el.top / this.dpi) * 254.0;
        this.store.updateTextLocation(
          this.productId,
          this.variantId,
          this.imageToPreview,
          index,
          obj.text,
          obj.dragLocation.x,
          obj.dragLocation.y,
          obj.textArc,
          obj.fontID,
          obj.fontSizeID
        );
      } else if (type == "art") {
        obj =
          this.store.userDesigns[this.productId].designs[this.variantId]
            .imgVariants[this.imageToPreview].arts[index];
        // obj.dragLocation.x = (el.left / this.dpi) * 254.0;
        // obj.dragLocation.y = (el.top / this.dpi) * 254.0;
        // var ratio = trans.width / trans.height;
        var width = this.extractFloatNumber(e.target.style.width) * trans.scale.scaleX;

          if(width >= this.getMinWidthArtSize(obj.artID) && width <= this.getMaxWidthArtSize(obj.artID)) {
            // e.target.style.transform = e.drag.transform;
            // document.getElementById("target-container").style.transform = e.drag.transform;
            
            e.target.style.transform = e.drag.transform;
            //להחזיר
            this.store.userDesigns[this.productId].designs[this.variantId].imgVariants[this.imageToPreview].arts[index].dragTransform = trans;


        // var newSizeId = this.store.findingNearestArtSize(this.store.userDesigns[this.productId].designs[this.variantId].imgVariants[this.imageToPreview].arts[index], this.dpi);
        // this.store.userDesigns[this.productId].designs[this.variantId].imgVariants[this.imageToPreview].arts[index].artSizeID = newSizeId;
          }
        // if(width < this.getMinWidthArtSize(obj.artID)) {
        //   trans.width = this.getMinWidthArtSize(obj.artID);
        //   trans.height = this.getMinWidthArtSize(obj.artID) / ratio;
        // } else if(trans.width > this.getMaxWidthArtSize(obj.artID)) {
        //   width = this.getMaxWidthArtSize(obj.artID);
        //   height = this.getMaxWidthArtSize(obj.artID) / ratio;
        // }
          // obj.dragTransform = trans;
      
        //מבצע את השינוי בגודל רק אם הגודל החדש גדול מהגודל המינימלי וקטן מהמקסימלי
      
        // this.store.updateArtLocation(
        //   this.productId,
        //   this.variantId,
        //   this.imageToPreview,
        //   index,
        //   this.store.userDesigns[this.productId].designs[this.variantId]
        //     .imgVariants[this.imageToPreview].arts[index].artArc
        // );
      } else if (type == "monogram") {
        obj =
          this.store.userDesigns[this.productId].designs[this.variantId]
            .imgVariants[this.imageToPreview].monograms[index];
        // obj.dragLocation.x = (el.left / this.dpi) * 254.0;
        // obj.dragLocation.y = (el.top / this.dpi) * 254.0;
        obj.location = this.store.getMonogramLocation(
          this.store.allMonograms.value[obj.monogramID],
          obj.distance1,
          obj.distance2,
          obj.align,
          obj.leftChar,
          obj.middleChar,
          obj.rightChar,
          obj.dragLocation.x,
          obj.dragLocation.y
        ).location;
      }
    },
    onRotate(e, type, index) {
      // console.log('dpi = ', this.dpi);
      var trans = this.getStyleByTransform(e.transform, this.extractFloatNumber(e.target.style.width) * 254 / this.dpi, this.extractFloatNumber(e.target.style.height) * 254 / this.dpi);
      this.selectElementToPreview(type, index);
      var obj = null;
      if (type == "text") {
        obj =
          this.store.userDesigns[this.productId].designs[this.variantId]
            .imgVariants[this.imageToPreview].texts[index];
        // obj.dragLocation.x = (el.left / this.dpi) * 254.0;
        // obj.dragLocation.y = (el.top / this.dpi) * 254.0;
        this.store.updateTextLocation(
          this.productId,
          this.variantId,
          this.imageToPreview,
          index,
          obj.text,
          obj.dragLocation.x,
          obj.dragLocation.y,
          obj.textArc,
          obj.fontID,
          obj.fontSizeID
        );
      } else if (type == "art") {
        obj =
          this.store.userDesigns[this.productId].designs[this.variantId]
            .imgVariants[this.imageToPreview].arts[index];
        // obj.dragLocation.x = (el.left / this.dpi) * 254.0;
        // obj.dragLocation.y = (el.top / this.dpi) * 254.0;
        // var ratio = trans.width / trans.height;        
        // var width = this.extractFloatNumber(e.target.style.width) * trans.scale.scaleX;

          // if(width >= this.getMinWidthArtSize(obj.artID) && width <= this.getMaxWidthArtSize(obj.artID)) {
            // e.target.style.transform = e.drag.transform;
            // document.getElementById("target-container").style.transform = e.drag.transform;
            
            //להחזיר
            this.store.userDesigns[this.productId].designs[this.variantId].imgVariants[this.imageToPreview].arts[index].dragTransform = trans;
          // }
          e.target.style.transform = e.drag.transform;
        // if(width < this.getMinWidthArtSize(obj.artID)) {
        //   trans.width = this.getMinWidthArtSize(obj.artID);
        //   trans.height = this.getMinWidthArtSize(obj.artID) / ratio;
        // } else if(trans.width > this.getMaxWidthArtSize(obj.artID)) {
        //   width = this.getMaxWidthArtSize(obj.artID);
        //   height = this.getMaxWidthArtSize(obj.artID) / ratio;
        // }

          // obj.dragTransform = trans;
      
        //מבצע את השינוי בגודל רק אם הגודל החדש גדול מהגודל המינימלי וקטן מהמקסימלי
      
        // this.store.updateArtLocation(
        //   this.productId,
        //   this.variantId,
        //   this.imageToPreview,
        //   index,
        //   this.store.userDesigns[this.productId].designs[this.variantId]
        //     .imgVariants[this.imageToPreview].arts[index].artArc
        // );
      } else if (type == "monogram") {
        obj =
          this.store.userDesigns[this.productId].designs[this.variantId]
            .imgVariants[this.imageToPreview].monograms[index];
        // obj.dragLocation.x = (el.left / this.dpi) * 254.0;
        // obj.dragLocation.y = (el.top / this.dpi) * 254.0;
        obj.location = this.store.getMonogramLocation(
          this.store.allMonograms.value[obj.monogramID],
          obj.distance1,
          obj.distance2,
          obj.align,
          obj.leftChar,
          obj.middleChar,
          obj.rightChar,
          obj.dragLocation.x,
          obj.dragLocation.y
        ).location;
      }
    },
    extractFloatNumber(originalString) { //"31.5591px" -> 31.5591
      const match = originalString.match(/[\d.]+/);
      return match ? parseFloat(match[0]) : 0;
    },
    getMinWidthArtSize(artId) {
      var sizesList = Object.values(this.store.getAllArtSizes(artId)).map(m => m.dstfile.pixelWidth);
      return (Math.min(...sizesList) * this.dpi) / 254;
    },
    getMaxWidthArtSize(artId) {
      var sizesList = Object.values(this.store.getAllArtSizes(artId)).map(m => m.dstfile.pixelWidth);
      return (Math.max(...sizesList) * this.dpi) / 254;
    },
    async changeStyleByRef(type) {
      if(type == 'text') {
        console.log('change style to text');
      } else if(type == 'art') {
        var index = 0;
        // this.elementsMoveableArray.forEach(el => {
        //   var artObjectToShow = this.store.userDesigns[this.productId].designs[this.variantId].imgVariants[this.imageToPreview].arts[index];
        //   if (el != null) {
        //     el.target.style.transform = `translate(${artObjectToShow.dragTransform.x}px, ${artObjectToShow.dragTransform.y}px) scale(${artObjectToShow.dragTransform.scale.scaleX}, ${artObjectToShow.dragTransform.scale.scaleY}) rotate(${artObjectToShow.dragTransform.rotate}deg)`;
        //     el.target.style.height = `${artObjectToShow.dragTransform.height}px`;
        //     el.target.style.width = `${artObjectToShow.dragTransform.width}px`;
        //     // Object.values(el.children).forEach(child => {
        //     //   child.style.left = `${((artObjectToShow.location.x - artObjectToShow.dragLocation.x) * this.dpi) / 254.0}px`;
        //     //   child.style.top = `${((artObjectToShow.location.y - artObjectToShow.dragLocation.y) * this.dpi) / 254.0}px`;
        //     // });
        //   }
        //   index ++;
        // });
        await nextTick();
        this.elementsRefsArray.forEach(el => {
          var artObjectToShow = this.store.userDesigns[this.productId].designs[this.variantId].imgVariants[this.imageToPreview].arts[index];
          if (el != null) {
            var x = artObjectToShow.dragTransform.x * (254 / this.dpi) - ((1 - artObjectToShow.dragTransform.scale.scaleX) * (artObjectToShow.dragTransform.width * 254 / this.dpi));
            var y = artObjectToShow.dragTransform.y * (254 / this.dpi) - ((1 - artObjectToShow.dragTransform.scale.scaleY) * (artObjectToShow.dragTransform.height * 254 / this.dpi));
            el.style.transform = `translate(${x}px, ${y}px) scale(${artObjectToShow.dragTransform.scale.scaleX}, ${artObjectToShow.dragTransform.scale.scaleY}) rotate(${artObjectToShow.dragTransform.rotate}deg)`;
            el.style.height = `${artObjectToShow.dragTransform.height * this.dpi / 254}px`;
            el.style.width = `${artObjectToShow.dragTransform.width * this.dpi / 254}px`;
            Object.values(el.children).forEach(child => {
              child.style.left = `${((artObjectToShow.location.x - artObjectToShow.dragLocation.x) * this.dpi) / 254.0}px`;
              child.style.top = `${((artObjectToShow.location.y - artObjectToShow.dragLocation.y) * this.dpi) / 254.0}px`;
            });
          }
          index ++;
        });

        // :style="`transform: translate(${artObjectToShow.dragTransform.x}px, ${artObjectToShow.dragTransform.y}px) scale(${artObjectToShow.dragTransform.scale.scaleX}, ${artObjectToShow.dragTransform.scale.scaleY}) rotate(${artObjectToShow.dragTransform.rotate}deg);
        //                                   height: ${artObjectToShow.dragTransform.height}px;
        //                                   width: ${artObjectToShow.dragTransform.width}px;
        // elementsRefsArray.value
      } else if(type == 'monogram') {
        console.log('change style to monogram');
      }
    },
    increaseArtSize() {
      var artDesignObj = this.store.userDesigns[this.productId].designs[this.variantId].imgVariants[this.imageToPreview].arts[this.currentPreviewIndex];
      var previous = this.store.findingNextVirtualArtSize(artDesignObj, this.dpi);
      artDesignObj.dragTransform = previous.dragTransform;
      artDesignObj.dragSize.w = previous.dstSize.w;
      artDesignObj.dragSize.h = previous.dstSize.h;
      this.elementsRefsArray[this.currentPreviewIndex].style.transform = `translate(${artDesignObj.dragTransform.x}px, ${artDesignObj.dragTransform.y}px) scale(${artDesignObj.dragTransform.scale.scaleX}, ${artDesignObj.dragTransform.scale.scaleY}) rotate(${artDesignObj.dragTransform.rotate}deg)`;
      this.elementsRefsArray[this.currentPreviewIndex].style.width = `${artDesignObj.dragTransform.width}px`;
      this.elementsRefsArray[this.currentPreviewIndex].style.height = `${artDesignObj.dragTransform.height}px`;
    },
    decreaseArtSize() {
      //שומר את הפיקסלים של הגודל הנוכחי לפי הסקייל כי אולי מתח ידנית
      var artDesignObj = this.store.userDesigns[this.productId].designs[this.variantId].imgVariants[this.imageToPreview].arts[this.currentPreviewIndex];
      var previous = this.store.findingPreviouVirtualArtSize(artDesignObj, this.dpi);
      artDesignObj.dragTransform = previous.dragTransform;
      artDesignObj.dragSize.w = previous.dstSize.w;
      artDesignObj.dragSize.h = previous.dstSize.h;
      this.elementsRefsArray[this.currentPreviewIndex].style.transform = `translate(${artDesignObj.dragTransform.x}px, ${artDesignObj.dragTransform.y}px) scale(${artDesignObj.dragTransform.scale.scaleX}, ${artDesignObj.dragTransform.scale.scaleY}) rotate(${artDesignObj.dragTransform.rotate}deg)`;
      this.elementsRefsArray[this.currentPreviewIndex].style.width = `${artDesignObj.dragTransform.width}px`;
      this.elementsRefsArray[this.currentPreviewIndex].style.height = `${artDesignObj.dragTransform.height}px`;
      // await nextTick();
    },
    // updateArtTransform(artDesign) {
    //   // var artDesign = store.userDesigns[productId].designs[variantId].imgVariants[imageToPreview].arts[currentPreviewIndex];
    //   console.log('artDesign = ', artDesign);
    //   // artDesign.artSizeID = value;
    //   var w = this.store.allArts.value[artDesign.artID].sizes[artDesign.artSizeID].dstfile.pixelWidth; // * this.dpi) / 254; //new width
    //   var h = this.store.allArts.value[artDesign.artID].sizes[artDesign.artSizeID].dstfile.pixelHeight; // * this.dpi) / 254; //new height
    //   var newTransform = `translate(${artDesign.dragTransform.x + ((artDesign.dragTransform.width * artDesign.dragTransform.scale.scaleX) - w)}px, ${artDesign.dragTransform.y + ((artDesign.dragTransform.height * artDesign.dragTransform.scale.scaleY) - h)}px) scale(1 1) rotate(${artDesign.dragTransform.rotate}deg)`;
    //   var trans = this.getStyleByTransform(newTransform, w, h);
    //   artDesign.dragTransform = trans;
    // },
    getStyleByTransform(transformString, width, height) {
      // var transformString = 'translate(157px, 122.99999999999999px) scale(3.3038, 3.3038) rotate(-17.03187944027306deg)';

      // Extract the translate values (x and y)
      var translateMatch = transformString.match(/translate\(([^,]+), ([^)]+)\)/);
      var x = translateMatch ? parseFloat(translateMatch[1]) : 0;
      var y = translateMatch ? parseFloat(translateMatch[2]) : 0;

      // Extract the scale values
      var scaleMatch = transformString.match(/scale\(([^,]+), ([^)]+)\)/);
      var scaleX = scaleMatch ? parseFloat(scaleMatch[1]) : 1;
      var scaleY = scaleMatch ? parseFloat(scaleMatch[2]) : 1;

      // Extract the rotate value
      var rotateMatch = transformString.match(/rotate\(([^)]+)deg\)/);
      var rotate = rotateMatch ? parseFloat(rotateMatch[1]) : 0;

      // // Assuming width and height should be equal to scaleX and scaleY respectively for this context
      // var width = scaleX;
      // var height = scaleY;

      var topX = ((width * scaleX) - x) < 0 ? 0 : ((width * scaleX) - x);
      var topY = ((height * scaleY) - y) < 0 ? 0 : ((height * scaleY) - y);
      // var topX = ((x * scaleX) - width) < 0 ? 0 : ((x * scaleX) - width);
      // var topY = ((y * scaleY) - height) < 0 ? 0 : ((y * scaleY) - height);

      // this.artObjectToShow.artArc = rotate;
      var result = {
        // 'transformString': transformString,
        'x': (x + (1 - scaleX) * width) * 254 / this.dpi, //x - ((1 - scaleX) * width),
        'y': (y + (1 - scaleY) * height) * 254 / this.dpi, //y - ((1 - scaleY) * height),
        'width': width,
        'height': height,
        'scale': {
          'scaleX': scaleX,
          'scaleY': scaleY
        },
        'rotate': rotate,
        'topX': topX,
        'topY': topY,
      };
      return result;
      // console.log('transform = ', transformString);
      // console.log('x:', x);
      // console.log('y:', y);
      // console.log('width:', width);
      // console.log('height:', height);
      // console.log('scale:', scaleX);
      // console.log('rotate:', rotate);
      // console.log('topX:', topX);
      // console.log('topY:', topY);
    },
    changeArc(type, index) {
      this.boxKey++;
      switch (type) {
        case "art":
          var artObj =
            this.store.userDesigns[this.productId].designs[this.variantId]
              .imgVariants[this.imageToPreview].arts[index];
          this.store.updateArtLocation(
            this.productId,
            this.variantId,
            this.imageToPreview,
            index,
            artObj.artArc
          );
          break;
        case "text":
          var textObj =
            this.store.userDesigns[this.productId].designs[this.variantId]
              .imgVariants[this.imageToPreview].texts[index];
          this.store.updateTextLocation(
            this.productId,
            this.variantId,
            this.imageToPreview,
            index,
            textObj.text,
            textObj.dragLocation.x,
            textObj.dragLocation.y,
            textObj.textArc,
            textObj.fontID,
            textObj.fontSizeID
          );
          break;
        default:
          break;
      }
    },
    updateFont(currentPreviewIndex) {
      this.store.userDesigns[this.productId].designs[
        this.variantId
      ].imgVariants[this.imageToPreview].texts[currentPreviewIndex].fontSizeID =
        Object.values(this.store.getAllFontSizes(this.store.userDesigns[this.productId].designs[this.variantId]
              .imgVariants[this.imageToPreview].texts[currentPreviewIndex]
              .fontID)
          // this.store.allFonts.value[
          //   this.store.userDesigns[this.productId].designs[this.variantId]
          //     .imgVariants[this.imageToPreview].texts[currentPreviewIndex]
          //     .fontID
          // ].sizes
        )[0].sizeID;
      this.updateTextLocation(currentPreviewIndex);
    },
    updateTextLayersColors(textObjFromStore) {
      //בשינוי פונט - בודק כמה שכבות של צבעים שמורות בסטור
      //בודק כמה שכבות צריך בשביל הפונט החדש לפי האות שהוקלדה
      //מחסיר או מוסיף צבע לרשימת הצבעים בסטור
      //כל פעם יכול להיות שתוקלד אות עם צבע אחד יותר
      var currentLayers = textObjFromStore.layersColors.length;
      var maxLettersLayers = 
      Math.max(...Object.values(textObjFromStore.text).map(m => this.store.allFonts.value[textObjFromStore.fontID].sizes[textObjFromStore.fontSizeID]
            .DictCharacters[m].dstfile.layerCount));
      console.log('currentLayers = ', currentLayers);
      console.log('maxLettersLayers = ', maxLettersLayers);
      
      // this.store.allFonts.value[textObjFromStore.fontID].sizes[textObjFromStore.fontSizeID]
      //       .DictCharacters[textObjFromStore.text[textObjFromStore.text.length-1]].dstfile.layerCount;

      if(currentLayers < maxLettersLayers) { //אם חסרות שכבות בסטור - מוסיף את מספר השכבות הזה
        this.addColorLayer(textObjFromStore, maxLettersLayers - currentLayers);
      } else if (currentLayers > maxLettersLayers) { //אם יש יותר מידי שכבות בסטור - מוחק מה שצריך
        this.removeColorLayer(textObjFromStore, currentLayers - maxLettersLayers);
      }
    },
    addColorLayer(textObjFromStore, sumMissLayers) {
      var listColorsToAdd = this.store.getAllColors().slice(textObjFromStore.layersColors.length - 1, sumMissLayers).map(m => m.colorID);
      listColorsToAdd.forEach(colorID => {
        textObjFromStore.layersColors.push(colorID);
      });
    },
    removeColorLayer(textObjFromStore, sumLayersToRemove) {
      textObjFromStore.layersColors.splice(textObjFromStore.layersColors.length - sumLayersToRemove, sumLayersToRemove);
    },
    updateTextLocation(index) {
      var textObj =
        this.store.userDesigns[this.productId].designs[this.variantId]
          .imgVariants[this.imageToPreview].texts[index];
          this.updateTextLayersColors(textObj);
        this.store.updateTextLocation(
          this.productId,
          this.variantId,
          this.imageToPreview,
          index,
          textObj.text,
          textObj.dragLocation.x,
          textObj.dragLocation.y,
          textObj.textArc,
          textObj.fontID,
          textObj.fontSizeID
        );
        this.boxKey++;
      // }
    },
    // isAvailableChar(index, type, char) {
    //   var monogramDesObj =
    //     this.store.userDesigns[this.productId].designs[this.variantId]
    //       .imgVariants[this.imageToPreview].monograms[index];
    //   var monogramObj = this.store.allMonograms.value[monogramDesObj.monogramID];
    //   var allLetters = [];
    //   if(type == 'left') {
    //     allLetters = Object.keys(this.store.allFonts.value[monogramObj.leftChar.fontID].sizes[monogramObj.leftChar.fontSizeID].DictCharacters);  
    //   } else if(type == 'middle') {
    //     allLetters = Object.keys(this.store.allFonts.value[monogramObj.middleChar.fontID].sizes[monogramObj.middleChar.fontSizeID].DictCharacters);  
    //   } else {
    //     allLetters = Object.keys(this.store.allFonts.value[monogramObj.rightChar.fontID].sizes[monogramObj.rightChar.fontSizeID].DictCharacters);  
    //   }
    //   return allLetters.includes(char) ? true : false;
    // },
    // fixMonogramCharsAndLocation(el, index, type) {
    //   console.log(el);
    //   var monogramDesObj =
    //     this.store.userDesigns[this.productId].designs[this.variantId]
    //       .imgVariants[this.imageToPreview].monograms[index];
    //   var monogramObj = this.store.allMonograms.value[monogramDesObj.monogramID];
    //   var allLetters = [];
    //   if(type == 'left') {
    //     allLetters = Object.keys(this.store.allFonts.value[monogramObj.leftChar.fontID].sizes[monogramObj.leftChar.fontSizeID].DictCharacters);  
    //     monogramDesObj.leftChar = allLetters.includes(monogramObj.leftChar) ? monogramObj.leftChar : "";
    //   } else if(type == 'middle') {
    //     allLetters = Object.keys(this.store.allFonts.value[monogramObj.middleChar.fontID].sizes[monogramObj.middleChar.fontSizeID].DictCharacters);  
    //     monogramDesObj.middleChar = allLetters.includes(monogramObj.middleChar) ? monogramObj.middleChar : "";
    //   } else {
    //     allLetters = Object.keys(this.store.allFonts.value[monogramObj.rightChar.fontID].sizes[monogramObj.rightChar.fontSizeID].DictCharacters);  
    //     monogramDesObj.rightChar = allLetters.includes(monogramObj.rightChar) ? monogramObj.rightChar : "";
    //   }
    //   this.updateMonogramLocation(index);
    // },
    updateMonogramLocation(index) {
      var monogramObj =
        this.store.userDesigns[this.productId].designs[this.variantId]
          .imgVariants[this.imageToPreview].monograms[index];
      var result = this.store.getMonogramLocation(
        this.store.allMonograms.value[monogramObj.monogramID],
        monogramObj.distance1,
        monogramObj.distance2,
        monogramObj.align,
        monogramObj.leftChar,
        monogramObj.middleChar,
        monogramObj.rightChar,
        monogramObj.location[0] ? monogramObj.location[0].x : 0,
        monogramObj.location[0] ? monogramObj.location[0].y : 0
      );
      monogramObj.location = result.location;
      monogramObj.dragSize = result.dragSize;
    },
    getMonogramDragSize() {
      var monogramObj =
        this.store.userDesigns[this.productId].designs[this.variantId]
          .imgVariants[this.imageToPreview].monograms[this.currentPreviewIndex];
      return this.store.getMonogramLocation(
        this.store.allMonograms.value[monogramObj.monogramID],
        monogramObj.distance1,
        monogramObj.distance2,
        monogramObj.align,
        monogramObj.leftChar,
        monogramObj.middleChar,
        monogramObj.rightChar,
        monogramObj.location[0] ? monogramObj.location[0].x : 0,
        monogramObj.location[0] ? monogramObj.location[0].y : 0
      ).dragSize;
    },
    getArtDragSize() {
      return this.store.getArtDragSize(this.store.allArts.value[this.getCurrentArt().artID].sizes[this.getCurrentArt().artSizeID],
       {x: 0, y: 0}, this.getCurrentArt().artArc).dragSize;
    },
    getCurrentMonogram() {
      return this.store.userDesigns[this.productId].designs[this.variantId]
        .imgVariants[this.imageToPreview].monograms[this.currentPreviewIndex];
    },    
    getCurrentArt() {
      return this.store.userDesigns[this.productId].designs[this.variantId]
        .imgVariants[this.imageToPreview].arts[this.currentPreviewIndex];
    },
    getCurrentProduct() {
      return this.store.allProducts[this.productId].variants[this.variantId]
        .images[this.imageToPreview];
    },
    // getMonogramDst(char, charType) {
    //   return this.store.getMonogramDst(
    //     this.getCurrentMonogram(),
    //     char,
    //     charType
    //   );
    // },
    getMaxDistance() {
      return (
        this.store.getMaxMonogramHeight(
          this.getCurrentMonogram().monogramID,
          this.getCurrentMonogram().leftChar,
          this.getCurrentMonogram().middleChar,
          this.getCurrentMonogram().rightChar
        ) / 2
      );
    },
    getArtTopLeft(artId, artSizeId, height, width, arc) {
      var newArc = Math.abs(arc) > 90 ? Math.abs(arc) - 90 : Math.abs(arc);
      var artWidth = this.store.allArts.value[artId].sizes[artSizeId].dstfile.pixelWidth * (this.dpi / 254.0);
      var artHeight = this.store.allArts.value[artId].sizes[artSizeId].dstfile.pixelHeight * (this.dpi / 254.0);
      var artBoxWidth = (Math.cos((Math.PI / 180) * Math.abs(newArc)) * artWidth) + (Math.sin((Math.PI / 180) * Math.abs(newArc)) * artHeight);
      var artBoxHeight = (Math.cos((Math.PI / 180) * Math.abs(newArc)) * artHeight) + (Math.sin((Math.PI / 180) * Math.abs(newArc)) * artWidth);
      var top = 0;
      var left = 0;
      if(artBoxHeight > artBoxWidth) {
        top = 0;
        left = (width - (artBoxWidth * (height / artBoxHeight))) / 2;
      } else if(artBoxWidth > artBoxHeight) {
        top = (height - (artBoxHeight * (width / artBoxWidth))) / 2;
        left = 0;
      } else {
        top = 0;
        left = 0;
      }      
      return {
        top: top,
        left: left
      };
    },
    getMonogramTopLeft(monogramId, height, width, char1, char2, char3, distance1, distance2) {
      var monoHeight = this.store.getMaxMonogramHeight(monogramId, char1, char2, char3) * (this.dpi / 254.0);
      var monoWidth = this.store.getMonogramWidth(this.store.allMonograms.value[monogramId], char1, char2, char3, distance1, distance2) * (this.dpi / 254.0);
      var top = 0;
      var left = 0;
      if(monoHeight > monoWidth) {
        top = 0;
        left = (width - (monoWidth * (height / monoHeight))) / 2;
      } else if(monoWidth > monoHeight) {
        top = (height - (monoHeight * (width / monoWidth))) / 2;
        left = 0;
      } else {
        top = 0;
        left = 0;
      }
      return {
        top: top,
        left: left
      };
    },
    getUserDesignsTextsContentful() {
      return Object.values(
        this.store.userDesigns[this.productId].designs[this.variantId]
          .imgVariants[this.imageToPreview].texts
      ).filter((x) => x.text != "");
    },
    getArtBySearch() {
      return this.store.getAllArtsBySearchText(this.searchArtText).filter(f => {
        if(this.filterByArtCategories.length == 0) {
          return f;
        } else if(f.artCategoryID != undefined&& !this.filterByArtCategories.includes(f.artCategoryID)) {
          return f;
        }
        // this.filterByArtCategories.length > 0 && f.artCategoryID != undefined&& !this.filterByArtCategories.includes(f.artCategoryID));
      })
    },
    getArtBySearchGroupByCategories() {
      //מסדר את כל התמונות לפי קטגוריות כאשר הקטגוריה עוד מופיעה בסוף הרשימה
    var resultByCategories = {};
    var catName = "";
    var moreCategory = null; // Store the 'More' category separately
    this.store.getAllArtsBySearchText(this.searchArtText).filter(f => {
        var moreObj = Object.values(this.store.allArtCategories.value).find(f => f.categoryName == 'More');
        var moreIndex = moreObj != null ? moreObj.categoryID : -1;
        if (this.filterByArtCategories.length == 0) {
            catName = (f.artCategoryID == undefined || (moreIndex != -1 && f.artCategoryID == moreIndex)) ? 'More' : this.store.allArtCategories.value[f.artCategoryID].categoryName;
            if (catName === 'More') {
              if (moreCategory == null) {
                moreCategory = {
                    categoryName: 'More',
                    artsList: [f]
                };
                } else {
                  moreCategory.artsList.push(f);
                }
                // moreCategory = {
                //     categoryName: 'More',
                //     artsList: [f]
                // };
            } else {
                if (resultByCategories[catName] == undefined) {
                    resultByCategories[catName] = {
                        categoryName: (f.artCategoryID == undefined || (moreIndex != -1 && f.artCategoryID == moreIndex)) ? 'More' : this.store.allArtCategories.value[f.artCategoryID].categoryName,
                        artsList: [f]
                    };
                } else {
                    resultByCategories[catName].artsList.push(f);
                }
            }
        } else if (f.artCategoryID != undefined && this.filterByArtCategories.includes(f.artCategoryID)) {
            catName = this.store.allArtCategories[f.artCategoryID].categoryName;
            if (resultByCategories[catName] == undefined) {
                resultByCategories[catName] = {
                    categoryName: this.store.allArtCategories.value[f.artCategoryID].categoryName,
                    artsList: [f]
                };
            } else {
                resultByCategories[catName].artsList.push(f);
            }
        }
    });

    // If 'More' category exists, add it to the result
    if (moreCategory) {
        resultByCategories['More'] = moreCategory;
    }

    return resultByCategories;
},
    // getArtBySearchGroupByCategories() {
    //   var resultByCategories = {};
    //   var catName = "";
    //   this.store.getAllArtsBySearchText(this.searchArtText).filter(f => {
    //     var moreObj = Object.values(this.store.allArtCategories).find(f => f.categoryName == 'More');
    //     var moreIndex = moreObj != null ? moreObj.categoryID : -1;
    //     if(this.filterByArtCategories.length == 0) {
    //       catName = (f.artCategoryID == undefined || (moreIndex != -1 && f.artCategoryID == moreIndex)) ? 'More' : this.store.allArtCategories[f.artCategoryID].categoryName;
    //       if(resultByCategories[catName] == undefined) {
    //         resultByCategories[catName] = {
    //        categoryName: (f.artCategoryID == undefined || (moreIndex != -1 && f.artCategoryID == moreIndex)) ? 'More' : this.store.allArtCategories[f.artCategoryID].categoryName,
    //        artsList: [f]
    //       };
    //       } else {
    //         resultByCategories[catName].artsList.push(f);
    //       }          
    //     } else if(f.artCategoryID != undefined && this.filterByArtCategories.includes(f.artCategoryID)) {
    //       catName = this.store.allArtCategories[f.artCategoryID].categoryName;
    //       if(resultByCategories[catName] == undefined) {
    //         resultByCategories[catName] = {
    //           categoryName: this.store.allArtCategories[f.artCategoryID].categoryName,
    //           artsList: [f]
    //         };
    //     } else {
    //         resultByCategories[catName].artsList.push(f);
    //       } 
    //     // this.filterByArtCategories.length > 0 && f.artCategoryID != undefined&& !this.filterByArtCategories.includes(f.artCategoryID));
    //   }
    // });
    //   return resultByCategories;
    // },
    filterByArtCategory() {
      this.filterByArtCategories.push(1);
    },
    ShowAllElements(typeToShow) {
      this.currentPreview = typeToShow;
      if(typeToShow == "text") {
        if(this.store.userDesigns[this.productId].designs[this.variantId]
        .imgVariants[this.imageToPreview].texts.length == 0) {
        this.addTextToDesign();
        }
        else {
          this.currentPreviewIndex =
            this.store.userDesigns[this.productId].designs[this.variantId]
              .imgVariants[this.imageToPreview].texts.length - 1;
        }
      } else if(typeToShow == "art") {
        if(this.store.userDesigns[this.productId].designs[this.variantId]
        .imgVariants[this.imageToPreview].arts.length == 0) {
        this.addArt();
        }
        else {
          this.currentPreviewIndex =
            this.store.userDesigns[this.productId].designs[this.variantId]
              .imgVariants[this.imageToPreview].arts.length - 1;
        }
      } else {
        if(this.store.userDesigns[this.productId].designs[this.variantId]
        .imgVariants[this.imageToPreview].monograms.length == 0) {
        this.addMonogram();
        }
        else {
          this.currentPreviewIndex =
            this.store.userDesigns[this.productId].designs[this.variantId]
              .imgVariants[this.imageToPreview].monograms.length - 1;
        }
      }

      //this.store.clearProductDesignFromUserDesign(this.productId, this.variantId, this.imageToPreview);
      
      // this.currentPreviewIndex = -1;
    },
    closeChangePopup(type) {
      if(type == 'art') {
        this.changeSelectedArt = false;
      } else if(type == 'monogram') {
        this.changeSelectedMonogram = false;
      }
    },
    delDesign() {
      if (confirm("Are you sure you want to delete the design?") == true) {
        this.exitScroll();
        this.store.clearProductDesignFromUserDesign(
          this.productId,
          this.variantId,
          this.imageToPreview
        );
      }
    },
    clearAllUserDesigns() {
      //this.store.userDesigns = {};
      Object.values(this.store.allProducts[this.productId].variants[this.variantId].images).forEach(img => {
      //Object.values(this.store.allProducts[this.productID].designs[this.variantId].imgVariants).forEach(img => {
        img.isUseful = true;
      });
    },
    exitScroll() {
      
      this.currentPreviewIndex = -1;
      
    },
    copyToClipBoard() {
      var textToCopy = {
        'userDesign': this.store.userDesigns,
      'allProduct': this.store.allProducts
      };
      console.log('enter to copyToClipBoard function');
      console.log('the store text is:  ', textToCopy);
      navigator.clipboard.writeText(JSON.stringify(textToCopy));      
    },
  },
};
</script>

<style scoped>
.vue-input input {
  border: none !important;
  background: none !important;
  outline: none !important;
  box-shadow: none !important;
  padding: 0 !important;
}
.vue-input {
  border: none !important;
  background: none !important;
  outline: none !important;
  box-shadow: none !important;
  padding: 0 !important;
}

.form-range{
  width: 100% ;
  display: flex;
    gap: 8px;
    justify-content: flex-end;
    align-items: center;
}

.font-layers-colors-container {
  background-color: blue;
display: flex !important;;
gap: 8px;
flex-wrap: nowrap;
align-items: flex-end;
flex-direction: row-reverse;
}
.spinner-border {
  width: 6rem;
  height: 6rem;
}
.vue-select {
  width: 100%;
  height: 100%;
}
.active-align {
  /* background-color: aliceblue; */
  border: 2px solid rgb(114, 152, 79);
  border-radius: 0.5em;
}
.align-option {
  border: 0.5px solid #58595B;
  border-radius: 0.5em;
}

.design-side {
  width: 97%;
  overflow-y: auto;
  padding: 16px;
  position: absolute;
  /* height: calc(100% - 30px); */
  height: calc(100% - 16px - 30px - 16px);
}
 .all-design-side {
    background-color: #F9F9F9;
    position: relative;
    height: 100%;
    border-radius: 8px;
    /* height: calc(100% - 120px - 22px); */
}
.dd-color > span {
  height: 20px;
  width: 20px;
  border-radius: 5px;
  display: inline-block;
}
.contain-order {
  flex-direction: row;
  width: 100%;
  display: flex;
  height: 100%;
}
.contain-modal {
  height: calc(100% - 24.19px);
}
.prev-char-monogram {
  max-height: 33.6px;
  display: flex;
  flex-direction: row;
}
.prev-dst-char-monogram {
  position: relative;
  width: 30px;
  height: 30px;
  left: -10px;
}
.left-preview {
  width: 40%;
  margin-right: 5px;
}
.emb-canvas-and-product-images {
  display: flex;
  width: max-content;
}
.emb-canvas-with-editind {
  display: grid;
}
.emb-order {
  /* order: 1; */
  width: 60%;
  margin-left: auto;
  display: grid;
  /* align-items: center; */
  flex-direction: row-reverse;
  margin-left: 5px;
}
.bg-image {
  height: 8vw;
  position: relative;
  width: 8vw;
  border: solid 2px #6f974c;
  margin: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}
/* .texts-order {
  order: 2;
} */
/* .btn-order {
  order: 3;
} */
.preview-order {
  order: 4;
  height: calc(100% - 100px);
}
.badge-color {
  background-color: #6f974c !important;
}
.badges {
  margin-bottom: 5vh;
}
.icon-menu {
  border-style: outset;
}
.item-line {
  background-color: #58595B;
  width: 100%;
  display: block;
  border-radius: 0.5rem;
  margin-bottom: 10px;
  height: 30px;
  align-items: center;
  display: flex;
  justify-content: space-between;
}
.item-line-text {
  color: #FFFFFF;
  font-size: 14px;
}
.openLine {
  margin-top: 20px;
}
.float-left {
  float: left;
  margin-left: 25px;
}
.floatRight {
  float: right;
  display: flex;
  align-items: center;
  height: inherit;
}
.delete-icon-span {
  height: inherit;
  width: 34px;
  display: grid;
    justify-items: center;
    align-items: center;
  /* background: rgba(217, 217, 217, 0.5);
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0px 0.5em 0.5em 0px; */
}
.delete-icon-span:hover {
  background: rgba(217, 217, 217, 0.5);
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0px 0.5em 0.5em 0px;
}
.open-line-icon-span {
  
  height: inherit;
  width: 34px;
  display: grid;
    justify-items: center;
    align-items: center;
}
.open-line-icon-span:hover {
  background: rgba(217, 217, 217, 0.5);
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
}
.lableInOpenLine {
  width: 33%;
  text-align: left;
  font-size: 16px;
}
.propLine {
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  align-items: center;
}
.openLineInput {
  /* background-color: #f0f0f0; */
  background-color: #FFFFFF !important;
  height: 35px;
  border: 0.5px solid #58595B !important;
  border-radius: 8px;
  align-content: center;
  align-items: center;
  display: grid;
  font-size: 14px;
}
.font-txt-preview {
    /* position: relative; */
    display: flex;
    justify-content: flex-start;
    /* gap: 15px; */
    width: 100%;
    /* flex-direction: row-reverse; */
}
.txt-preview-comp {
    gap: 15px;
    position: relative;
    height: 25px;
    display: flex;
    /* width: 45px; */
}
span.font-name {
    text-align: right;
}
.char-mono-lable {
  font-size: 14px;
}
.char-input {
  width: 40px;
  height: 35px;
  text-align: center;
}
.public-btn-add-del {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 16px 16px 5px 16px;
  flex-direction: row-reverse;
}
.btn-add {
  align-items: center;
  display: flex;
  justify-content: center;
  /* width: max-content; */
  width: 100%;
  padding: 8px;
  height: max-content;
}
.btn-to-add-element {
  background-color: #72984F;  
  /* width: 100px; */
  width: auto;
  padding: 10px;
  color: white;
}
.reset-arc {
  width: 30px;
  height: 30px;
  background-color: #FFFFFF;
  /* background-color: #f0f0f0; */
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.5em;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
}
/* .btn-to-change-element:hover {
  box-shadow: rgba(0, 0, 0, 0.25) 2px 4px 7px;
} */
.btn-to-del-all-element {
  margin-right: 4px;
  /* width: 30px; */  
  color: rgba(88, 89, 91, 1);
  /* width: 135px; */
  width: auto;
  padding: 10px;
  height: 30px;
  border: 1px solid #72984F;
  border-radius: 0.5em;
}
.public-button {
    height: 30px;
    border-radius: 0.5em;
    display: flex;
    gap: 6px;
    font-size: 12px;
    /* color: rgba(88, 89, 91, 1); */
    /* width: 135px;; */
    justify-content: center;
    flex-direction: row-reverse;
    align-items: center;



  /* width: fit-content; */
  /* float: right; */
  /* margin-right: 4px; */
  /* width: 30px;
  height: 30px; */
  /* border-radius: 0.5em;
  display: grid;
  align-items: center;
  justify-content: center; */
}
.des-monogram-char {
  display: flex;
  height: 50px;
  justify-content: space-evenly;
  /* justify-content: center; */
  align-items: center;
  background-color: #f0f0f0;
  border-radius: 0.5em;
}
.colors-inputs {
    display: grid;
    grid-template-columns: auto auto;
    width: 100%;
    max-height: 85px;
    gap: 5px;
    overflow-y: auto;
    padding: 10px;
}
.colors-select-line {
  display: grid;
  grid-template-columns: v-bind('smallColorsLine == true ? "auto auto auto auto" : "auto auto auto auto auto"');
  /* grid-template-columns: v-bind('($refs.colorsSelectLineRef != undefined ? $refs.colorsSelectLineRef.getBoundingClientRect().width : "0") > "300" ? "auto auto auto auto auto;" : "auto auto auto auto;"'); */
  width: 100%;
  gap: 5px;
  padding: 10px;
}
.dd-color {
  display: flex;
  align-items: center;
  border: 1px solid rgba(88, 89, 91, 1);
  width: 137px;;
  border-radius: 5px;
}
.sub-buttons {
  display: flex;
  justify-content: space-between;
  padding: 0px 15px 0px 15px;
  height: 100px;
}
.btn-radio {
  box-sizing: border-box;
  position: relative;
  /* width: 126px; */
  width: 100%;
  /* width: 33%; */
  height: 100%;
  /* height: 120px; */
  justify-content: center;
  /* width: 150px; */
  padding: 16px 16px 8px 16px;
  /* display: grid; */
}
.inner-btn-sub {
  box-sizing: border-box;
  position: relative;
  border: 1px solid;
  border-radius: 8px;
  /* width: 113px; */
  width: 100%;
  /* height: 100%; */
  padding: 16px;
  height: calc(100% - 17.6px);
  /* background-size: 33%; */
  /* background-size: contain; */
}
.inner-btn-icon {
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  height: 100%;
  width: 100%;
}
.circle-btn {
  box-sizing: border-box;
  position: absolute;
  background-color: rgb(255, 255, 255);
  border: 1px solid #72984F;
  width: 27px;
  height: 27px;
  border-radius: 2em;
  top: -9px;
  right: -9px;
  display: grid;
  font-size: 16px;
  align-items: center;
}
.gallery-elements {
  max-height: 25vh;
  position: relative;
  display: flex;
  width: 100%;
  overflow-y: auto;
  /* align-items: flex-start; */
  gap: 10px;
  border: 1px solid;
  border-radius: 0.5em;
  max-height: 190px;
  padding: 10px;
  flex-wrap: wrap;
}
.qty {
  display: flex;
  place-items: center;
  justify-content: center;
}
.qty:hover {
  cursor: default;
}
.design-header {
  font-size: 16px;
  float: left !important;
}
.btn-sub-img-span {
    height: 40px;
}
.zoom-icon-span {
  display: none;
}
.buy-btn {
  width: 100%;
}
/* .buttons-flex {
  order: 3;    
  display: flex;
  justify-content: space-between;
  position: absolute;
  bottom: 0px;
  right: calc(15vh + 16px + 2px);
  width: 580px;
} */
.buttons-flex-mobile {
  display: none;
}
.footer {
  display: none;
}
.buttons-flex-full-screan {
  /* display: flex; */
  /* justify-content: space-between; */
  display: grid;
  grid-template-columns: auto auto auto;
  /* grid-template-columns: v-bind('isDesignCartElement == true ? "auto auto auto" : "auto auto auto"'); */
  width: calc(100% - 8vw);
  align-items: center;
  gap: 5%;
  font-size: 14px;
}
.cancle-distance {
  height: 25px;
  width: 25px;
  border-radius: 0.5em;
  background-color: #FFFFFF;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  display: grid;
  justify-content: center;
  align-items: center;
}
.add-to-cart-btn {
  border: 1px solid #72984F;
  border-radius: 0.5em;
}
.add-to-cart-btn:hover {
  cursor: pointer;
}

.update-btn {
  display: grid;
  justify-items: center; 
  margin-left: 10px;
}

.update-btn:hover {
  cursor: pointer;
}
/* .close-btn {
  border: 1px solid #72984F;
  border-radius: 0.5em;
} */
.buy-now-btn {
  background: #72984F;
  border-radius: 0.5em;
}
.buy-now-btn:hover {
  cursor: pointer;
}
.update-des-btn {
  background: #72984F;
  border-radius: 0.5em;
}

.update-des-btn:hover {
    cursor: pointer;
}
.art-categories-container {
    text-align: justify;
}
/* .arrow-downward {
    right: 0px;
    position: absolute;
    margin-right: 25px !important;
} */
@media screen and (max-width: 1190px) {
  .inner-btn-icon {
    padding: 10px;
  }
  /* .des-monogram-char {
    width: 40%;
  } */
}
@media screen and (max-width: 960px) {
  /* .btn-sub-img-span {
    height: 25px;
  } */
  .inner-btn-icon {
    padding: 8px;
  }
}
@media screen and (max-width: 768px) {  
  .buttons-flex-mobile {
    display: block;
    order: 3;
    /* display: flex; */
    /* width: calc(100% - 13vw); */
    /* width: calc(100%); */
    width: inherit;
    /* justify-content: space-between; */
    /* align-items: center; */
    margin: 5px;
    display: grid;
    grid-template-columns: auto auto;
    gap: 5%;
  }
  .qty {
    display: none;
  }
  .bg-image {
    width: 13vw;
    height: 13vw;
  }
  .footer {
    display: block;
  }
  .buttons-flex-full-screan {
    display: none;
  }
  /* .modal-dialog {
    max-width: 97vw !important;
    max-height: 90vh !important;
} */
  .zoom-icon-span {
    display: block;
    position: absolute;
    left: 30px;
    top: 60px;
    z-index: 1;
    background: #EAEAEA;
    border-radius: 8px;
    height: 35px;
    width: 35px;
    display: grid;
    align-items: center;
    justify-items: center;
  }
  .contain-order {
    flex-direction: column;
    /* height: calc(100% - 100px); */
    height: 100%;
  }
  .contain-modal {
    height: calc(100% - 27.2px);
  }
  .left-preview {
    width: 100%;
    order: 2;
    margin-right: 0px;
    height: inherit;
  }
  .preview-order {
    height: calc(100% - 80px);
  }
  .emb-order {
    /* order: 1; */
    width: 100%;
    margin-left: 0px;
  }
  .lay-colors {
    margin-top: 100px;
  }
  .product-images {
    justify-content: center !important;
  }
  .emb-canvas {
    max-width: calc(100vw - 16px - 16px - 13vw);
    height: v-bind('"calc((100vw - 16px - 16px - 13vw) * " + (productId != null? (getCurrentProduct().file.pixelHeight / getCurrentProduct().file.pixelWidth) : 0) + ") "');
  }
  .emb-canvas-and-product-images {
    order: 1;
    width: 100%;
  }
  .all-design-side {
    background-color: #FFFFFF;
  }
  .public-btn-add-del {
    padding: 12px 12px 4px 12px;
  }
  .design-side {
    overflow-y: unset;
    /* height: 140px; */
    padding: 16px;
    width: 100%;
  }
  .circle-btn {
    box-sizing: border-box;
    position: absolute;
    background-color: rgb(255, 255, 255);
    border: 1px solid #72984F;
    width: 27px;
    height: 27px;
    border-radius: 1em;
    right: -9px;
    top: -9px;
  }
  .buy-now-btn {
    width: 100%;
  }
  .add-to-cart-btn {
    width: 100%;
  }
  .btn-sub-img-span {
    height: 27px;
  }  
  .sub-buttons {
    height: 80px;
  }
  .inner-btn-sub {
    padding: 9px;
  }
}

@media screen and (max-width: 600px) {
  .emb-canvas-and-product-images {
    display: grid;
  }
  .product-images {
    display: grid;
    position: absolute;
    bottom: 0px;
  }
  .emb-canvas {
    max-width: calc(100vw - 16px - 16px);
    height: v-bind('"calc((100vw - 16px - 16px) * " + (productId != null? (getCurrentProduct().file.pixelHeight / getCurrentProduct().file.pixelWidth) : 0) + ") "');
  }
  .bg-image {
    height: 13vw;
    width: 13vw;
  }
  .public-btn-add-del {
    padding-top: 8px;
  }
  .design-side {
    padding: 8px;
  }
  .btn-radio {
    padding: 10px 10px 8px 10px;
  }
}

@media screen and (max-width: 450px) {
  .buttons-flex-mobile {
      font-size: 12px;
  }
  .sub-buttons {
    height: 75px;
  }
  .btn-radio {
    padding: 10px 6px 8px 6px;
  }
  .inner-btn-sub {
    padding: 7px;
  }
  .item-line {
    margin-bottom: 3px;
  }
  .design-side {
    height: calc(100% - 42px);
  }
  .openLine {
    margin-top: 0px;
  }
}

@media screen and (max-width: 845px) {
  .sub-buttons {
      padding: 0px;
  }
}

</style>

<!-- <style>
.modal-dialog {
  height: inherit !important;
}
.modal-content {
  height: inherit;
}
.form-outline.form-control {
  margin: 5px;
  text-transform: none;
}
.row.vue-select {
  margin: 5px;
}
.form-counter {
  display: none !important;
}
.vue-dropdown-item {
  display: flex;
  position: relative;
}
.vue-dropdown-item.selected.highlighted {
  background-color: #f3f3f3;
}
.vue-dropdown-item.highlighted {
  background-color: #f3f3f3;
}
.vue-dropdown {
  overflow-x: hidden;
}
.btn {
  text-transform: none;
}

/* .v-input__control {
    border: 0.5px solid #58595B !important;
    outline: none;
    border-radius: 8px;
}
.v-field--active:focus-visible {
  outline: none;
}
.v-field__overlay:focus-visible {
  outline: none;
}
.v-field__outline:focus-visible {
  outline: none;
} */

.custom-select {
  height: 35px;
  width: 100px;
  font-size: 12px;
}

.contain-modal .vue-select-header {
  width: 100% !important;
  height: 100% !important;
  /* width: auto !important;
  height: auto !important; */
  padding-left: 0.75em !important;
  padding-right: 0.75em !important;
  position: absolute !important;
  justify-self: center !important;
}
.font-selected > .vue-select-header {
    width: 100% !important;
}
.form-range {
  height: 100% !important;
}
.modal-content {
  color: rgba(88, 89, 91, 1);
}
.range {
  width: 100%;
}
.vue-input input {
  font-size: 14px !important;
}
.modal-body {
  position: absolute;
/* padding-bottom: 0px; */
  max-width: 100vw;
  max-height: 100vh;
  height: inherit;
  width: inherit;
  border-radius: 0;
  /* max-width: 80vw;
  max-height: 90vh; */
}
.footer {
  margin: 0px !important;
  padding: 3px !important;
}
@media only screen and (max-width: 768px) {
.modal.fade .modal-dialog {
  max-width: 100vw !important;
  max-height: 100vh !important;
}
  /* .modal-dialog {
    max-width: 97vw !important;
    max-height: 90vh !important;
  }   */
  .modal-body {
    overflow-y: auto;
    height: inherit;
    max-width: 100%;
  }
  .modal-footer {
    flex-direction: row-reverse;
  }
}

/* .modal-dialog {
    max-width: 100vw !important;
    max-height: 100vh !important;
    height: 100vh !important;
    width: 100vw !important;
    margin: 0px !important;
  }
  .modal-dialog-centered {
    max-width: 100vw !important;
    max-height: 100vh !important;
    height: 100vh !important;
    width: 100vw !important;
    margin: 0px !important;
  } */

@media screen and (max-width: 600px) {
  .modal-body {
    padding: 6px;
  }
  /* .modal-dialog .modal-dialog-centered {
    max-width: 100vw !important;
    max-height: 100vh !important;
    height: 100vh !important;
    width: 100vw !important;
    margin: 0px !important;
  }

  .modal-content {
    width: inherit;
    height: inherit;
    border-radius: 0px;
  }

  .modal-body {
    max-width: inherit;
    max-height: inherit;
  } */
}
</style> -->


<!-- style to the new Moveable -->
 
<!-- <style>
.rCS19atnxs .moveable-control.moveable-origin {
    width: 8px;
    height: 8px;
}
.rCS19atnxs .moveable-control {
    border: 1px solid black;
    background: white;
    width: 8px;
    height: 8px;
}
.rCS19atnxs .moveable-rotation {
  height: calc(20px* var(--zoom));
}
</style> -->

